export default {
  es: {
    common: {
      // Navigation
      dashboard: "Dashboard",
      campaigns: "Campañas",
      templates: "Templates",
      categories: "Categorías",
      advertisers: "Advertisers",
      accounts: "Cuentas",
      account: "Cuenta",
      users: "Usuarios",
      profiles: "Perfiles",
      operators: "Operadores",
      countries: "Países",
      scenarioTypes: "Tipos de Escenario",
      services: "Servicios",
      auditLog: "Auditoría",

      // Actions
      create: "Crear",
      edit: "Editar",
      update: "Actualizar",
      delete: "Eliminar",
      view: "Ver",
      save: "Guardar",
      cancel: "Cancelar",
      close: "Cerrar",
      back: "Volver",
      search: "Buscar",
      filter: "Filtrar",
      clearFilters: "Limpiar Filtros",
      confirmDelete: "Confirmar Eliminación",
      actions: "Acciones",
      deleteSelected: "Eliminar Seleccionados",
      clearSelection: "Limpiar Selección",
      clearAll: "Limpiar Todo",

      // Status (column/label: use common.statusLabel; options: common.status.active, etc.)
      status: {
        active: "Activo",
        inactive: "Inactivo",
        pending: "Pendiente",
        suspended: "Suspendido",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
      },
      statusLabel: "Estado",

      // Status object for nested access
      statusTypes: {
        active: "Activo",
        inactive: "Inactivo",
        pending: "Pendiente",
        suspended: "Suspendido",
        enabled: "Habilitado",
        disabled: "Deshabilitado",
      },

      // Dates
      created: "Creado",
      modified: "Modificado",

      // Validation
      required: "Este campo es requerido",
      invalidEmail: "Email inválido",
      invalidPhone: "Teléfono inválido",
      invalidUrl: "URL inválida",
      positiveValue: "El valor debe ser positivo",
      selectUser: "Debe seleccionar un usuario",
      selectVariable: "Debe seleccionar una variable",
      msisdnFormat: "MSISDN debe contener entre 7 y 15 dígitos",
      positive: "El valor debe ser positivo",
      positiveNumber: "Debe ser un número positivo",
      validNumber: "Debe ser un número válido",

      // Messages
      loading: "Cargando...",
      noData: "No hay datos disponibles",
      none: "Ninguno",
      error: "Error",
      success: "Éxito",
      accessDenied: "Acceso Denegado",
      yes: "Sí",
      no: "No",

      // Status (direct access)
      active: "Activo",
      inactive: "Inactivo",

      // Error messages
      errorMessages: {
        saving: "Error al guardar",
        loading: "Error al cargar",
        deleting: "Error al eliminar",
        updating: "Error al actualizar",
        creating: "Error al crear",
      },

      // Validation nested object
      validation: {
        required: "Este campo es requerido",
        email: "Debe ser un email válido",
        minLength: "Debe tener al menos {min} caracteres",
        maxLength: "No puede tener más de {max} caracteres",
        numeric: "Debe ser un número válido",
        url: "Debe ser una URL válida",
        msisdnFormat: "MSISDN debe contener entre 7 y 15 dígitos",
      },
      backendAccessRequired: "Se requiere acceso al backend para usar esta aplicación",
      retry: "Reintentar",
      currentLanguage: "Idioma Actual",
      default: "Por Defecto",
      native: "Nativo",
      browserLanguage: "Idioma del Navegador",
      browserDetected: "Detectado por el Navegador",

      // Pagination
      itemsPerPage: "Elementos por página",
      pageText: "Página",
      page: "Página",
      of: "de",
      nextPage: "Siguiente página",
      prevPage: "Página anterior",
      firstPage: "Primera página",
      lastPage: "Última página",
      id: "ID",
      locale: "es-ES",
      all: "Todos",
      pageOf: "{page} de {total}",
      pageRange: "{start}-{end} de {total}",
      notAvailable: "N/A",
      showing: "Mostrando",
      items: "elementos",
    },

    // Errors
    errors: {
      loadingCommercialAdmins: "Error al cargar los administradores comerciales",
      loadingOperationalAdmins: "Error al cargar los administradores operacionales",
      loadingUsers: "Error al cargar los usuarios disponibles",
      loadingBlacklistEntries: "Error al cargar las entradas de blacklist",
      loadingValidators: "Error al cargar los validadores",
      loadingData: "Error cargando datos",
      loadingTemplate: "Error cargando template",
      loadingAccount: "Error cargando cuenta",
      savingAdmin: "Error al guardar el administrador",
      savingValidator: "Error al guardar el validador",
      savingTemplate: "Error al guardar el template",
      deletingAdmin: "Error al eliminar el administrador",
      deletingValidator: "Error al eliminar el validador",
      openingModal: "Error al abrir el modal",
      msisdnAlreadyExists: "Este MSISDN ya está en la blacklist para esta cuenta",
      invalidMsisdnFormat: "Formato de MSISDN inválido",
      addingMsisdnToBlacklist: "Error al agregar MSISDN a la blacklist",
      deletingMsisdnFromBlacklist: "Error al eliminar MSISDN de la blacklist",
      loadingOperators: "Error al cargar los operadores",
    },

    // Campaigns
    campaigns: {
      title: "Campañas",
      subtitle: "Gestiona las campañas del sistema",
      createTitle: "Crear Campaña",
      createSubtitle: "Crea una nueva campaña",
      editTitle: "Editar Campaña",
      editSubtitle: "Modifica los datos de la campaña",
      name: "Nombre",
      type: "Tipo",
      account: "Cuenta",
      advertiser: "Advertiser",
      category: "Categoría",
      subcategory: "Subcategoría",
      status: "Estado",
      price: "Precio",
      startDate: "Fecha de Inicio",
      endDate: "Fecha de Fin",
      audience: "Audiencia",
      retryType: "Tipo de Reintento",
      engineImage: "Imagen del Motor",
      createSuccess: "Campaña creada exitosamente",
      updateSuccess: "Campaña actualizada exitosamente",
      deleteSuccess: "Campaña eliminada exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar la campaña "{name}"?',
      details: "Detalles",
      basicInfo: "Información Básica",
      campaignStatus: "Estado",
      notSet: "No establecido",
      quickActions: "Acciones Rápidas",
      editCampaign: "Editar Campaña",
      viewStatistics: "Ver Estadísticas",
      mtAmount: "Cantidad MT",
    },

    // Campaign Form
    campaignForm: {
      basicInfo: "Información Básica",
      actions: "Acciones",
      saveCampaign: "Guardar Campaña",
      backToList: "Volver al Listado",
      accountInfo: "Información de Cuenta",
      schedule: "Cronograma",
      startDateTime: "Fecha y Hora de Inicio",
      endDateTime: "Fecha y Hora de Fin",
      finishedDateTime: "Fecha y Hora de Finalización",
      advancedConfig: "Configuración Avanzada",
    },

    // Templates
    templates: {
      title: "Templates",
      subtitle: "Gestiona los templates del sistema",
      createTitle: "Crear Template",
      createSubtitle: "Crea un nuevo template",
      editTitle: "Editar Template",
      editSubtitle: "Modifica los datos del template",
      name: "Nombre",
      status: "Estado",
      account: "Cuenta",
      advertiser: "Advertiser",
      category: "Categoría",
      subcategory: "Subcategoría",
      price: "Precio",
      description: "Descripción",
      createSuccess: "Template creado exitosamente",
      updateSuccess: "Template actualizado exitosamente",
      deleteSuccess: "Template eliminado exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el template "{name}"?',
      basicInfo: "Información Básica",
      statusApproved: "Aprobado",
      statusPending: "Pendiente",
      statusRejected: "Rechazado",
      statusArchived: "Archivado",
      updatedSuccessfully: "Template actualizado exitosamente",
      createdSuccessfully: "Template creado exitosamente",
      // Template fields
      fields: {
        name: "Nombre",
        user: "Usuario",
        category: "Categoría",
        subcategory: "Subcategoría",
        account: "Cuenta",
        advertiser: "Advertiser",
        price: "Precio",
        status: "Estado",
      },
      // Template status
      statusTypes: {
        pending: "Pendiente",
        approved: "Aprobado",
        rejected: "Rechazado",
      },
    },

    // MSISDN Validators
    msisdnValidator: {
      title: "Validador MSISDN",
      create: "Crear Validador",
      edit: "Editar Validador",
      createDescription: "Crea un nuevo validador MSISDN para un país específico",
      editDescription: "Modifica la configuración del validador MSISDN",
      loading: "Cargando validador...",
      validatorInfo: "Información del Validador",
      countryCode: "Código de País",
      countryCodeHint: "Código numérico del país (ej: 54 para Argentina)",
      lengthRange: "Rango de Longitud",
      minLength: "Longitud Mínima",
      maxLength: "Longitud Máxima",
      action: "Acción",
      addCountryCode: "Agregar Código de País",
      trimCountryCode: "Recortar Código de País",
      maxLengthError: "La longitud máxima debe ser mayor o igual a {minlen}",
      createdSuccessfully: "Validador creado exitosamente",
      updatedSuccessfully: "Validador actualizado exitosamente",
    },

    msisdnValidators: {
      title: "Validadores MSISDN",
      description: "Gestiona las reglas de validación de números de teléfono por país",
      newValidator: "Nuevo Validador",
      searchByCountryCode: "Buscar por código de país",
      filterByAction: "Filtrar por acción",
      addCountryCode: "Agregar código",
      trimCountryCode: "Recortar código",
      addCode: "Agregar código",
      trimCode: "Recortar código",
      countryCode: "Código de País",
      showingResults: "Mostrando {filtered} de {total} resultados",
      lengthRange: "Rango de Longitud",
      action: "Acción",
      autocomplete: "Autocompletado",
      createTitle: "Crear Validador",
      editTitle: "Editar Validador",
      minLength: "Longitud Mínima",
      maxLength: "Longitud Máxima",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el validador para el país "{countryCode}"?',
      createSuccess: "Validador creado exitosamente",
      updateSuccess: "Validador actualizado exitosamente",
      deleteSuccess: "Validador eliminado exitosamente",
      createdSuccessfully: "Validador creado exitosamente",
      updatedSuccessfully: "Validador actualizado exitosamente",
      deletedSuccessfully: "Validador eliminado exitosamente",
    },

    // Categories
    categories: {
      title: "Categorías",
      subtitle: "Gestiona las categorías y subcategorías",
      createTitle: "Crear Categoría",
      createSubtitle: "Crea una nueva categoría",
      editTitle: "Editar Categoría",
      editSubtitle: "Modifica los datos de la categoría",
      information: "Información de la Categoría",
      name: "Nombre",
      subcategories: "Subcategorías",
      svgId: "ID SVG",
      createSuccess: "Categoría creada exitosamente",
      updateSuccess: "Categoría actualizada exitosamente",
      deleteSuccess: "Categoría eliminada exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar la categoría "{name}"?',
      subcategoryCreateSuccess: "Subcategoría creada exitosamente",
      subcategoryUpdateSuccess: "Subcategoría actualizada exitosamente",
      subcategoryDeleteSuccess: "Subcategoría eliminada exitosamente",
      fields: {
        name: "Nombre",
        description: "Descripción",
        subcategories: "Subcategorías",
        svgId: "ID SVG",
      },
    },

    // Advertisers
    advertisers: {
      title: "Advertisers",
      subtitle: "Gestiona los advertisers del sistema",
      createTitle: "Crear Advertiser",
      createSubtitle: "Crea un nuevo advertiser",
      editTitle: "Editar Advertiser",
      editSubtitle: "Modifica los datos del advertiser",
      name: "Nombre",
      createSuccess: "Advertiser creado exitosamente",
      updateSuccess: "Advertiser actualizado exitosamente",
      deleteSuccess: "Advertiser eliminado exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el advertiser "{name}"?',
    },

    subscriptionServices: {
      title: "Servicios de suscripción",
      serviceName: "Nombre",
      account: "Cuenta",
      advertiser: "Anunciante",
      price: "Precio",
      activations: "Activaciones",
      additionalActivations: "Activaciones adicionales",
      filterAccount: "Filtrar por cuenta",
      filterAdvertiser: "Filtrar por anunciante",
      editTitle: "Editar activaciones",
      updateSuccess: "Servicio actualizado correctamente",
      noData: "No hay servicios de suscripción",
      noDataFiltered: "No hay resultados con los filtros aplicados",
      nonNegativeInteger: "Debe ser un entero mayor o igual a 0",
    },

    // Accounts
    accounts: {
      title: "Cuentas",
      subtitle: "Gestiona las cuentas del sistema",
      createTitle: "Crear Cuenta",
      createSubtitle: "Crea una nueva cuenta",
      editTitle: "Editar Cuenta",
      editSubtitle: "Modifica los datos de la cuenta",
      name: "Nombre",
      advertiser: "Advertiser",
      balance: "Balance",
      currency: "Moneda",
      timezone: "Zona Horaria",
      contactName: "Nombre de Contacto",
      contactEmail: "Email de Contacto",
      contactPhone: "Teléfono de Contacto",
      website: "Sitio Web",
      address: "Dirección",
      city: "Ciudad",
      state: "Estado/Provincia",
      zipCode: "Código Postal",
      country: "País",
      description: "Descripción",
      taxId: "ID Fiscal",
      businessId: "ID de Negocio",
      basicInfo: "Información Básica",
      contactInfo: "Información de Contacto",
      addressInfo: "Información de Dirección",
      additionalInfo: "Información Adicional",
      location: "Ubicación",
      commercialAdmins: "Administradores Comerciales",
      operationalAdmins: "Administradores Operacionales",
      paymentMethods: "Métodos de Pago",
      paymentMethod: "Método de Pago",
      accountNumber: "Número de Cuenta",
      createSuccess: "Cuenta creada exitosamente",
      updateSuccess: "Cuenta actualizada exitosamente",
      deleteSuccess: "Cuenta eliminada exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar la cuenta "{name}"?',

      // Account Form
      form: {
        editTitle: "Editar Cuenta",
        createTitle: "Crear Nueva Cuenta",
        editSubtitle: "Modifica la información de la cuenta",
        createSubtitle: "Completa la información para crear una nueva cuenta",
        basicInfo: "Información Básica",
        accountName: "Nombre de la Cuenta",
        accountType: "Tipo de Cuenta",
        operator: "Operador",
        msisdnValidator: "Validador MSISDN",
        active: "Activa",
        antiSpamConfig: "Configuración Anti-spam",
        antiSpamType: "Tipo de Anti-spam",
        impressionsAmount: "Cantidad de Impresiones",
        perDays: "Por Días",
        loadingAccountInfo: "Cargando información de la cuenta...",
        updateSuccess: "Cuenta actualizada exitosamente",
        createSuccess: "Cuenta creada exitosamente",
        errorLoadingData: "Error cargando datos: {message}",
        errorLoadingAccount: "Error cargando cuenta: {message}",
        errorSavingAccount: "Error guardando cuenta: {message}",
        tooltip: {
          msisdnValidator: "Validador MSISDN: Define las reglas de validación para números de teléfono según el país.",
          countryCode: "Código de país: Identifica el país",
          length: "Longitud: Rango de dígitos permitidos",
          action: "Acción: Cómo manejar el código de país",
          addCode: "Agregar código",
          trimCode: "Recortar código",
          code: "Código: {code} | Longitud: {min}-{max}",
        },
      },
    },

    // Accounts List
    accountsList: {
      title: "Cuentas",
      newAccount: "Nueva Cuenta",
      filters: "Filtros",
      clearFilters: "Limpiar Filtros",
      search: "Buscar",
      searchPlaceholder: "Nombre de cuenta o ID...",
      status: "Estado",
      all: "Todas",
      active: "Activa",
      inactive: "Inactiva",
      operator: "Operador",
      results: "resultados",
      result: "resultado",
      noResultsWithFilters: "No se encontraron cuentas que coincidan con los filtros aplicados",
      accountType: "Tipo de cuenta",
      antiSpamType: "Tipo Anti-spam",
      impressions: "Impresiones",
      perDays: "Por días",
      configure: "Configurar",
      deactivate: "Desactivar",
      activate: "Activar",
      confirmDeactivation: "Confirmar desactivación",
      confirmDeactivationMessage: '¿Estás seguro de que quieres desactivar la cuenta "{name}"?',
      confirmActivation: "Confirmar activación",
      confirmActivationMessage: '¿Estás seguro de que quieres activar la cuenta "{name}"?',
      note: "Nota",
      deactivationNote: "La cuenta se desactivará pero no se eliminará del sistema.",
    },

    // Account Components
    account: {
      // Blacklist Second Action
      blacklistSecondAction: "Blacklist Second Action",
      addMsisdn: "Agregar MSISDN",
      deleteMsisdn: "Eliminar MSISDN",
      addMsisdnToBlacklist: "Agregar MSISDN a Blacklist",
      msisdn: "MSISDN",
      msisdnPlaceholder: "Ej: 1234567890",
      msisdnHint: "Ingrese el número de teléfono sin espacios ni guiones",
      creationDate: "Fecha de Creación",
      confirmDeleteMsisdn: "¿Estás seguro de que quieres eliminar el MSISDN {msisdn} de la blacklist?",
      msisdnAddedSuccessfully: "MSISDN agregado a la blacklist correctamente",
      msisdnDeletedSuccessfully: "MSISDN eliminado de la blacklist correctamente",

      // Tooltip
      howItWorks: "¿Cómo funciona?",
      blacklistDescription1:
        "Este listado de MSISDN NO va a recibir second action. Todos los cambios demoran hasta 1 hora en actualizarse en el backend.",
      blacklistDescription2:
        "Cuando recibimos el evento para procesar el SA, filtramos por este listado de MSISDN. Si no está en la lista, encolamos y luego ejecutamos el SA.",

      // Commercial Admins
      commercialAdmins: "Administradores Comerciales",
      addCommercial: "Agregar Comercial",
      addCommercialAdmin: "Agregar Administrador Comercial",
      deleteCommercial: "Eliminar comercial",
      confirmDeleteAdmin:
        '¿Estás seguro de que quieres eliminar al administrador "{name}" ({username}) de esta cuenta?',
      adminAddedSuccessfully: "Administrador agregado correctamente",
      adminDeletedSuccessfully: "Administrador eliminado correctamente",

      // Operational Admins
      operationalAdmins: "Administradores Operacionales",
      addOperational: "Agregar Operacional",
      addOperationalAdmin: "Agregar Administrador Operacional",
      deleteOperational: "Eliminar operacional",

      // Account Variables
      accountVariables: "Variables de la Cuenta",
      editVariable: "Editar Variable",
      addVariable: "Agregar Variable",
      deleteVariable: "Eliminar variable",
      selectedVariable: "Variable seleccionada",
      defaultValue: "Valor por defecto",
      variable: "Variable",
      accountValue: "Valor de la Cuenta",
      accountValuePlaceholder: "Ingrese el valor para esta cuenta",

      // Common fields
      user: "Usuario",
      username: "Usuario",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Email",
    },

    // Users
    users: {
      title: "Usuarios",
      subtitle: "Gestiona los usuarios del sistema",
      createTitle: "Crear Usuario",
      createSubtitle: "Crea un nuevo usuario",
      createUser: "Crear Usuario",
      editTitle: "Editar Usuario",
      editSubtitle: "Modifica los datos del usuario",
      editUser: "Editar Usuario",
      username: "Usuario",
      email: "Email",
      firstname: "Nombre",
      lastname: "Apellido",
      fullName: "Nombre Completo",
      role: "Rol",
      admin: "Administrador",
      manager: "Manager",
      operator: "Operador",
      user: "Usuario",
      unknown: "Desconocido",
      enable: "Habilitar",
      disable: "Deshabilitar",
      password: "Contraseña",
      confirmPassword: "Confirmar Contraseña",
      position: "Cargo",
      defaultLanguage: "Idioma por Defecto",
      selectedAccount: "Cuenta Seleccionada",
      landingPage: "Página de Inicio",
      backendAccess: "Acceso al Backend",
      basicInfo: "Información Básica",
      passwordInfo: "Información de Contraseña",
      roleAndStatus: "Rol y Estado",
      additionalInfo: "Información Adicional",
      associations: "Asociaciones",
      userProfiles: "Perfiles de Usuario",
      account: "Cuenta",
      profile: "Perfil",
      invalidUsername: "El usuario debe tener entre 3 y 20 caracteres alfanuméricos",
      passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
      passwordMismatch: "Las contraseñas no coinciden",
      enableSuccess: "Usuario habilitado exitosamente",
      disableSuccess: "Usuario deshabilitado exitosamente",
      createSuccess: "Usuario creado exitosamente",
      updateSuccess: "Usuario actualizado exitosamente",
      saveSuccess: "Usuario guardado exitosamente",
      deleteSuccess: "Usuario eliminado exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el usuario "{name}"?',
      changePassword: "Cambiar Contraseña",
      passwordUpdateSuccess: "Contraseña actualizada y enviada por email",
      passwordUpdateSuccessNoEmail: "Contraseña actualizada. No se pudo enviar el email de aviso",
      temporaryPasswordNotice: "El usuario deberá definir una nueva contraseña al ingresar. Esta contraseña temporal vence en 30 días.",
      temporaryPasswordEmailNotice: "Se enviará por email a {email}.",
      createSuccessEmailSent: "Usuario creado. Se envió el mail de bienvenida a {email}",
      createSuccessNoEmail: "Usuario creado. No se pudo enviar el mail de bienvenida: reenviálo desde Seguridad",
      welcomeEmailCreateNotice: "Al crear el usuario se le enviará un mail con su usuario, esta contraseña temporal y el link de acceso. Deberá cambiarla al ingresar; vence en 30 días.",
      welcomeEmailTitle: "Mail de bienvenida",
      welcomeEmailDescription: "Si el usuario no recibió el mail con sus datos de acceso, se lo puede reenviar. Se genera una contraseña temporal nueva y la anterior deja de funcionar.",
      welcomeEmailResend: "Reenviar mail de bienvenida",
      welcomeEmailConfirmTitle: "Reenviar mail de bienvenida",
      welcomeEmailConfirmText: "Se generará una nueva contraseña temporal y se enviará a {email}. La contraseña anterior dejará de funcionar.",
      welcomeEmailResent: "Mail de bienvenida reenviado a {email}",
      welcomeEmailResentNoEmail: "Se generó una contraseña nueva pero no se pudo enviar el mail. Reintentá en unos minutos.",
      welcomeEmailNoEmail: "El usuario no tiene email cargado",
      welcomeEmailAlreadyLoggedInTitle: "No se puede reenviar el mail de bienvenida",
      welcomeEmailAlreadyLoggedInText: "El usuario ya ingresó a la plataforma, por eso no se le puede reenviar el mail de bienvenida. Te recomendamos restablecer su contraseña: le llegará un mail con una contraseña temporal.",
      welcomeEmailResetPassword: "Restablecer contraseña",
      welcomeEmailError: "No se pudo reenviar el mail de bienvenida",

      // User fields
      fields: {
        username: "Usuario",
        email: "Email",
        firstname: "Nombre",
        lastname: "Apellido",
        status: "Estado",
        advertiser: "Anunciante",
        position: "Cargo",
        defaultLanguage: "Idioma por Defecto",
        backendAccess: "Acceso al Backend",
        subdomainAccess: "Acceso a Subdominio",
        landingPage: "Página de Inicio",
        selectedAccount: "Cuenta Seleccionada",
        password: "Contraseña",
        newPassword: "Nueva Contraseña",
        confirmPassword: "Confirmar Contraseña",
      },
    },

    // Profiles
    profiles: {
      title: "Perfiles",
      subtitle: "Gestiona los perfiles y privilegios",
      createTitle: "Crear Perfil",
      createSubtitle: "Crea un nuevo perfil",
      editTitle: "Editar Perfil",
      editSubtitle: "Modifica los datos del perfil",
      editProfile: "Editar Perfil",
      name: "Nombre",
      description: "Descripción",
      scope: "Alcance",
      fields: {
        name: "Nombre",
        scope: "Alcance",
      },
      scopeOptions: {
        accountId: "ID de Cuenta",
        advertiserId: "ID de Advertiser",
      },
      privileges: "Privilegios",
      privilegesDescription: "Gestiona los privilegios asignados a este perfil",
      privilegeName: "Nombre del Privilegio",
      privilegeDescription: "Descripción",
      privilegeStatus: "Estado",
      privilegeToggle: "Activar/Desactivar",
      noPrivilegesFound: "No se encontraron privilegios",
      noPrivilegesDescription: "No hay privilegios disponibles para mostrar",
      nameRequired: "El nombre del perfil es requerido",
      global: "Global",
      account: "Cuenta",
      advertiser: "Advertiser",
      managePrivileges: "Gestionar Privilegios",
      privilegesUpdateSuccess: "Privilegios actualizados exitosamente",
      createSuccess: "Perfil creado exitosamente",
      updateSuccess: "Perfil actualizado exitosamente",
      deleteSuccess: "Perfil eliminado exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el perfil "{name}"?',
      messages: {
        created: "Perfil creado exitosamente",
        updated: "Perfil actualizado exitosamente",
        deleted: "Perfil eliminado exitosamente",
      },
      reports: "Reportes",
      manageReports: "Gestionar Reportes",
      reportsDescription: "Gestiona los reportes asignados a este perfil",
      availableReports: "Reportes Disponibles",
      assignedReports: "Reportes Asignados",
      noReportsAssigned: "No hay reportes asignados",
      noReportsAvailable: "No hay reportes disponibles",
      addReport: "Agregar Reporte",
      removeReport: "Remover Reporte",
      reportName: "Nombre del Reporte",
      reportComponent: "Componente",
      reportsUpdateSuccess: "Reportes del perfil actualizados exitosamente",
      reportAddedSuccess: "Reporte agregado al perfil exitosamente",
      reportRemovedSuccess: "Reporte removido del perfil exitosamente",
    },

    // Operators
    operators: {
      title: "Operadores",
      subtitle: "Gestiona los operadores del sistema",
      createTitle: "Crear Operador",
      createSubtitle: "Crea un nuevo operador",
      editTitle: "Editar Operador",
      editSubtitle: "Modifica los datos del operador",
      name: "Nombre",
      code: "Código",
      description: "Descripción",
      phoneCode: "Código de Teléfono",
      website: "Sitio Web",
      supportEmail: "Email de Soporte",
      notes: "Notas",
      invalidCode: "El código debe tener entre 2 y 10 caracteres alfanuméricos",
      invalidPhoneCode: "Código de teléfono inválido",
      enable: "Habilitar",
      disable: "Deshabilitar",
      enableSuccess: "Operador habilitado exitosamente",
      disableSuccess: "Operador deshabilitado exitosamente",
      createSuccess: "Operador creado exitosamente",
      updateSuccess: "Operador actualizado exitosamente",
      deleteSuccess: "Operador eliminado exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el operador "{name}"?',

      // Operator fields
      fields: {
        name: "Nombre",
        country: "País",
        status: "Estado",
        active: "Activo",
        maxImpactsPerUser: "Máx. Impactos por Usuario",
        maxImpactsPeriod: "Período Máx. Impactos",
      },
    },

    // Countries
    countries: {
      title: "Países",
      subtitle: "Gestiona los países del sistema",
      createTitle: "Crear País",
      createSubtitle: "Crea un nuevo país",
      editTitle: "Editar País",
      editSubtitle: "Modifica los datos del país",
      name: "Nombre",
      code: "Código",
      phoneCode: "Código de Teléfono",
      currency: "Moneda",
      timezone: "Zona Horaria",
      language: "Idioma",
      description: "Descripción",
      active: "Activo",
      defaultCountry: "País por Defecto",
      invalidCountryCode: "El código debe tener 2-3 letras mayúsculas",
      invalidPhoneCode: "Código de teléfono inválido",
      invalidTimezone: "Formato de zona horaria inválido (ej: UTC-5)",
      invalidLanguage: "Código de idioma inválido (ej: es)",
      createSuccess: "País creado exitosamente",
      updateSuccess: "País actualizado exitosamente",
      deleteSuccess: "País eliminado exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el país "{name}"?',
      searchPlaceholder: "Nombre o código de país...",
      noResultsWithFilters: "No se encontraron países con los filtros aplicados",
      noDataAvailable: "No hay países disponibles",
      resultsCount: "{count} resultado{count, plural, =1 {} other {s}}",
      countryCodeHint: "Código de 2 letras (ej: AR, US)",
      timezoneHint: "Zona horaria (ej: America/Argentina/Buenos_Aires)",
      phoneCodeHint: "Código telefónico (ej: 54)",
      mccHint: "Mobile Country Code",
      geolocationHint: "Información de geolocalización en formato JSON",

      // Country fields
      fields: {
        name: "Nombre",
        countrycode: "Código de País",
        timezone: "Zona Horaria",
        phonecode: "Código de Teléfono",
        mcc: "MCC",
        geolocation: "Geolocalización",
      },

      // Validation messages
      validation: {
        countryCodeFormat: "Código de país debe ser 2 letras mayúsculas",
        phoneCodePositive: "Código telefónico debe ser un número positivo",
        mccPositive: "MCC debe ser un número positivo",
        invalidJsonFormat: "Formato JSON inválido en geolocalización",
      },
    },

    // Scenario Types
    scenarioTypes: {
      title: "Tipos de Escenario",
      subtitle: "Gestiona los tipos de escenario",
      createTitle: "Crear Tipo de Escenario",
      createSubtitle: "Crea un nuevo tipo de escenario",
      editTitle: "Editar Tipo de Escenario",
      editSubtitle: "Modifica los datos del tipo de escenario",
      name: "Nombre",
      description: "Descripción",
      category: "Categoría",
      variables: "Variables",
      basic: "Básico",
      advanced: "Avanzado",
      custom: "Personalizado",
      manageVariables: "Gestionar Variables",
      addVariable: "Agregar Variable",
      variableName: "Nombre de Variable",
      defaultValue: "Valor por Defecto",
      variablesUpdateSuccess: "Variables actualizadas exitosamente",
      createSuccess: "Tipo de escenario creado exitosamente",
      updateSuccess: "Tipo de escenario actualizado exitosamente",
      deleteSuccess: "Tipo de escenario eliminado exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el tipo de escenario "{name}"?',
      status: "Estado",
      templateFile: "Archivo de Plantilla",
      channelId: "ID de Canal",
      channelName: "Nombre del Canal",
      active: "Activo",
      hasMenu: "Tiene Menú",
      orderBy: "Ordenar Por",

      // Form fields
      fields: {
        name: "Nombre",
        templateFile: "Archivo de Plantilla",
        channelId: "ID de Canal",
        active: "Activo",
        hasMenu: "Tiene Menú",
        orderBy: "Ordenar Por",
      },
    },

    // Usuarios y Perfiles de Cuenta
    accountUserProfiles: {
      title: "Usuarios y Perfiles de la Cuenta",
      subtitle: "Gestiona los usuarios y sus perfiles para esta cuenta",
      addUser: "Agregar Usuario",
      editUserProfiles: "Editar Perfiles del Usuario",
      selectUser: "Seleccionar Usuario",
      selectProfiles: "Seleccionar Perfiles",
      user: "Usuario",
      profiles: "Perfiles",
      addSuccess: "Usuario agregado correctamente",
      updateSuccess: "Perfiles del usuario actualizados correctamente",
      removeProfileSuccess: "Perfil removido correctamente",
      removeUserSuccess: "Usuario removido de la cuenta correctamente",
      removeUserConfirm: "¿Estás seguro de que quieres remover a {name} de esta cuenta?",
    },

    // Tipos de Escenario de Cuenta
    accountScenarioTypes: {
      title: "Tipos de Escenario de la Cuenta",
      subtitle: "Gestiona los tipos de escenario para esta cuenta",
      addTitle: "Agregar Tipo de Escenario",
      addSubtitle: "Agrega un nuevo tipo de escenario a esta cuenta",
      editTitle: "Editar Tipo de Escenario",
      editSubtitle: "Modifica el tipo de escenario de esta cuenta",
      channel: "Canal",
      channelDescription: "El canal determina qué tipos de escenario estarán disponibles",
      scenarioType: "Tipo de Escenario",
      scenarioTypeDescription: "Tipos de escenario disponibles para el canal seleccionado",
      alias: "Alias (Opcional)",
      aliasHint: "Permite personalizar el nombre del escenario para esta cuenta",
      active: "Activo",
      additionalConfig: "Configuración Adicional",
      step1: "Paso 1: Seleccionar Canal",
      step2: "Paso 2: Seleccionar Tipo de Escenario",
      step3: "Paso 3: Configuración Adicional",
      clearSelection: "Limpiar Selección",
      completeRequiredFields: "Complete los campos requeridos",
      save: "Guardar",
      cancel: "Cancelar",
      addSuccess: "Tipo de escenario agregado correctamente",
      updateSuccess: "Tipo de escenario actualizado correctamente",
      deleteSuccess: "Tipo de escenario eliminado correctamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar el tipo de escenario "{name}" ({alias}) de esta cuenta?',
      noAlias: "Sin alias",
      manageVariables: "Administrar Variables",
      variablesForCampaigns: "Variables para Campañas",
      variablesForEvents: "Variables para Eventos",
      customVariablesForCampaigns: "Variables Personalizadas para Campañas",
      customVariablesForEvents: "Variables Personalizadas para Eventos",
      customizeVariableValues: "Personaliza los valores de las variables para este tipo de escenario",
      customizeVariableValuesEvents: "Personaliza los valores de las variables para eventos de este tipo de escenario",
      variable: "Variable",
      defaultValue: "Valor por Defecto",
      status: "Estado",
      actions: "Acciones",
      saved: "Guardado",
      notSaved: "Sin guardar",
      deleteVariable: "Eliminar Variable",
      saveVariable: "Guardar Variable",
      variableDeleted: "Variable eliminada correctamente",
      variableCreated: "Variable creada correctamente",
      variableUpdated: "Variable actualizada correctamente",
      close: "Cerrar",
      account: "Cuenta",
    },

    // Subcategories
    subcategories: {
      title: "Subcategorías",
      createTitle: "Crear Subcategoría",
      editTitle: "Editar Subcategoría",
      name: "Nombre",
      category: "Categoría",
      svgId: "ID de SVG",
      add: "Agregar",
      noData: "No hay subcategorías disponibles",
      placeholders: {
        name: "Nombre de la subcategoría...",
      },
      fields: {
        name: "Nombre",
      },
      createSuccess: "Subcategoría creada exitosamente",
      updateSuccess: "Subcategoría actualizada exitosamente",
      deleteSuccess: "Subcategoría eliminada exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar la subcategoría "{name}"?',
      error: {
        loading: "Error al cargar las subcategorías",
        creating: "Error al crear la subcategoría",
        deleting: "Error al eliminar la subcategoría",
      },
    },

    // Dashboard
    dashboard: {
      title: "Dashboard",
      totalCampaigns: "Total de Campañas",
      activeCampaigns: "Campañas Activas",
      totalRevenue: "Ingresos Totales",
      avgPrice: "Precio Promedio",
      quickActions: "Acciones Rápidas",
      createCampaign: "Crear Campaña",
      createTemplate: "Crear Template",
      createUser: "Crear Usuario",
      createAccount: "Crear Cuenta",
      systemStatus: "Estado del Sistema",
      apiServer: "Servidor API",
      online: "En Línea",
      database: "Base de Datos",
      cache: "Cache",
      performance: "Rendimiento",
      responseTime: "Tiempo de Respuesta",
      uptime: "Tiempo Activo",
      lastUpdate: "Última Actualización",
      editCampaign: "Editar Campanha",
      viewStatistics: "Ver Estatísticas",
      mtAmount: "Quantidade MT",
    },

    smppConnections: {
      title: "Conexiones SMPP",
      description: "Gestiona las conexiones SMPP de la cuenta",
      addConnection: "Agregar Conexión",
      createConnection: "Crear Conexión",
      editConnection: "Editar Conexión",
      noConnections: "No hay conexiones disponibles",
      name: "Nombre",
      url: "URL",
      urlSms: "URL SMS",
      urlFlashsms: "URL Flash SMS",
      urlStatus: "URL Status",
      throughput: "Throughput",
      throughputHint: "Mensajes por segundo",
      messagesPerSecond: "msg/s",
      status: "Estado",
      maxQueue: "Cola Máxima",
      usleepPerMsgSent: "Usleep por Mensaje",
      checkEachNSecs: "Verificar cada N segundos",
      checkStatus: "Verificar Estado",
      statusResults: "Resultados de Estado",
      testsTitle: "Pruebas de conexión SMPP",
      runTest: "Ejecutar Prueba",
      testType: "Tipo de prueba",
      msisdn: "MSISDN",
      message: "Mensaje",
      senderId: "Sender ID",
      messageCount: "Cantidad de mensajes",
      lastTestResult: "Último Resultado",
      testHistory: "Historial",
      testStatusSuccess: "Éxito",
      testStatusFailed: "Falló",
      mockNotice: "Esto es una prueba mock del cliente. La integración con backend está pendiente.",
      noTests: "Aún no se ejecutaron pruebas",
      createSuccess: "Conexión creada exitosamente",
      updateSuccess: "Conexión actualizada exitosamente",
      deleteSuccess: "Conexión eliminada exitosamente",
      deleteConfirm: '¿Estás seguro de que quieres eliminar la conexión "{name}"?',
      errorLoading: "Error al cargar conexiones",
      errorCheckingStatus: "Error al verificar el estado de la conexión",
      testDialog: {
        tabs: {
          fullExecution: "Ejecución completa de pruebas",
          unitTests: "Pruebas unitarias",
        },
        fullExecution: {
          title: "Pruebas validación de conexión:",
          presetsTitle: "Pruebas Predefinidas",
          presets: {
            sms: {
              title: "Envio de un SMS",
              subtitle: "Envía un SMS de prueba con el texto 'Test SMS'",
            },
            satPingPorOn: {
              title: "Envio de un SAT PING con PoR: ON",
              subtitle: "SAT mode PING, PoR ON",
            },
            satPingPorOff: {
              title: "Envio de un SAT PING con PoR: OFF",
              subtitle: "SAT mode PING, PoR OFF",
            },
            satMsgCapture: {
              title: "Envio de un SAT MSG (captura)",
              subtitle:
                'SAT mode MSG. Mensaje: "This message is a test. Please capture the screen and share the results"',
            },
          },
        },
        unitTests: {
          sendType: {
            sms: "SMS",
            flashSms: "FlashSMS",
            sat: "SAT",
          },
          dlrLabel: "DLR",
          on: "On",
          off: "Off",
          satModeLabel: "SAT mode",
          satModePing: "PING",
          satModeMsg: "MSG",
          porLabel: "PoR",
          true: "True",
          false: "False",
          satMsgLabel: "SAT MSG",
        },
        smsHint: {
          invalidCharsRemoved: "caracteres inválidos removidos",
          truncatedToLimit: "recortado al máximo permitido",
        },
      },
    },

    // Tools
    tools: {
      title: "Herramientas",
      subtitle: "Herramientas para ejecutar lambdas y consultar el estado de los servicios.",
      noToolsAvailable: "No hay herramientas disponibles",
      noToolsDescription: "Las herramientas aparecerán aquí cuando estén disponibles",
      lastExecution: "Última ejecución",
      execute: "Ejecutar",
      openTool: "Abrir Herramienta",
      reprocess: "Reprocesar",
      executionCompleted: "Ejecución completada exitosamente",
      error: "Error",
      result: "Resultado",
      close: "Cerrar",
      migration: "Migración",
      processes: "Procesos",
      campaignMigration: "Migración de Campañas",
      campaignMigrationDescription: "Mueve campañas entre diferentes cuentas",
      campaignMigrationSubtitle: "Mueve campañas entre cuentas de manera segura",
      movistarOcsJob: "Movistar OCS Job",
      movistarOcsJobDescription: "Reprocesa los jobs pendientes de Movistar OCS",
      movistarOcsBlockNotifications: "Bloquear notificaciones",
      runFullSegmentation: "Run-Full Segmentación",
      runFullSegmentationDescription: "Ejecuta el run-full de segmentación de Inngest con parámetros personalizados",
      runFullSegmentationDialogSubtitle: "Ejecuta el run-full de segmentación de Inngest",
      runFullSegmentationPrepaid: "Segmentación Entel Perú Prepago",
      runFullSegmentationPrepaidDescription: "Ejecuta el run-full de segmentación prepago (cuenta 169) con archivos S3",
      runFullSegmentationPrepaidDialogSubtitle: "Dispara la segmentación prepago en Inngest para la cuenta 169",
      runFullSegmentationPostpaid: "Segmentación Entel Perú Pospago",
      runFullSegmentationPostpaidDescription:
        "Ejecuta el run-full de segmentación pospago (cuenta 168) con carga de audiencia CSV",
      runFullSegmentationPostpaidDialogSubtitle: "Sube la audiencia a S3 y dispara la segmentación pospago en Inngest",
      cellcPaidSegmentation: "Segmentación Cell C PAID",
      cellcPaidSegmentationDescription:
        "Simula y confirma la segmentación PAID de Cell C (cuenta 136) vía Inngest",
      cellcPaidSegmentationDialogSubtitle: "Corre una simulación o confirma una corrida ya calculada para crear las campañas",
      createCampaignsFromFilesCardName: "Crear campañas desde archivos",
      createCampaignsFromFilesCardDescription:
        "Llama a Inngest api2.create-campaigns-from-files usando datos de Redis (generated-list)",
      createCampaignsFromFilesDialogTitle: "Crear campañas desde archivos",
      createCampaignsFromFilesDialogSubtitle:
        "Crea las campañas desde archivos usando el proceso de segmentación (Inngest api2.create-campaigns-from-files)",
      status: {
        online: "En Línea",
        offline: "Fuera de Línea",
        maintenance: "En Mantenimiento",
        unknown: "Desconocido",
      },
      createCampaignsFromFiles: {
        stepAccount: "Cuenta",
        stepAccountSubtitle: "Seleccionar cuenta",
        stepDay: "Día",
        stepDaySubtitle: "Seleccionar día disponible",
        stepConfirm: "Confirmación",
        stepConfirmSubtitle: "Revisar y ejecutar",
        accountTitle: "Cuenta",
        accountSubtitle: "Selecciona la cuenta para listar los días con generated-list en Redis",
        selectAccount: "Seleccionar cuenta",
        searchAccountsHint: "Escribe para buscar cuentas",
        dayTitle: "Día disponible",
        daySubtitle: "Selecciona el día del generated-list que deseas usar",
        noDays: "No hay días con generated-list para esta cuenta en Redis.",
        confirmTitle: "Confirmación",
        confirmSubtitle: "Revisa los datos antes de llamar a Inngest",
        summaryTitle: "Datos del generated-list (Redis)",
        account: "Cuenta",
        month: "Mes",
        bucketS3: "Bucket S3",
        keyZip: "Key ZIP",
        servicesCsvFiles: "Servicios y archivos CSV",
        servicesCount: "{count} servicio(s)",
        csvFilesCount: "{count} archivo(s) CSV",
        warningInngest: "Se enviará el evento api2.create-campaigns-from-files a Inngest con estos datos.",
        loadHashError: "No se pudo cargar el hash. Vuelve al paso anterior.",
        previous: "Anterior",
        next: "Siguiente",
        executeInngest: "Ejecutar Inngest",
        result: "Resultado",
        successTitle: "Ejecución exitosa",
        successMessage: "Evento enviado a Inngest correctamente",
        errorTitle: "Error",
        close: "Cerrar",
      },
    },

    // Entel Stats
    entelStats: {
      title: "Estadísticas Entel",
      subtitle: "Carga y edición de estadísticas mensuales de servicios Entel.",
      back: "Volver a Herramientas",
      selectMonth: "Mes",
      selectYear: "Año",
      services: "servicios",
      prepaid: "Entel Prepago",
      postpaid: "Entel Pospago",
      save: "Guardar",
      close: "Cerrar",
      noServices: "No hay servicios disponibles para esta cuenta",
      savedSuccess: "{saved} fila(s) guardadas, {skipped} omitida(s)",
      errorLoading: "Error al cargar estadísticas",
      errorSaving: "Error al guardar estadísticas",
      toolCardName: "Estadísticas Entel",
      toolCardDescription: "Carga y edición de estadísticas mensuales de servicios Entel Perú.",
      toolCardCategory: "Estadísticas",
      toolCardAction: "Ir a herramienta",
      cols: {
        service: "Servicio",
        advertiser: "Advertiser",
        activations: "Activaciones",
        finalsActivations: "Act. Finales",
        validAcceptances: "Aceptaciones Válidas",
        pending: "Pendientes",
        delivered: "Entregados",
        remainder: "Remanente",
      },
    },
    auditLog: {
      title: "Auditoría",
      subtitle: "Registro de acciones de usuarios contra la API",
      noData: "No hay registros de auditoría para los filtros aplicados",
      fields: {
        created_at: "Fecha",
        actor_email: "Usuario",
        user_id: "ID Usuario",
        category: "Categoría",
        action: "Acción",
        resource: "Recurso",
        resource_id: "ID Recurso",
        method: "Método",
        path: "Ruta",
        result: "Resultado",
        severity: "Severidad",
        source: "Origen",
        ip_address: "IP",
        user_agent: "User Agent",
        request_id: "Request ID",
        changes: "Cambios",
      },
      categories: { action: "Acción", security: "Seguridad" },
      results: { success: "Exitoso", failure: "Fallido" },
      severities: { low: "Baja", medium: "Media", high: "Alta", critical: "Crítica" },
      source: { hot: "Reciente", cold: "Histórico" },
      filters: {
        dateFrom: "Desde",
        dateTo: "Hasta",
        userId: "ID Usuario",
        actorEmail: "Usuario (email)",
        action: "Acción",
        resource: "Recurso",
        category: "Categoría",
        result: "Resultado",
        sortOrder: "Orden",
        sortDesc: "Más recientes primero",
        sortAsc: "Más antiguos primero",
        accounts: "Cuentas",
        account: "Cuenta",
        accountsPlaceholder: "Todas las cuentas",
      },
      detail: {
        title: "Detalle del Evento",
        event: "Evento",
        actor: "Actor",
        changes: "Cambios",
      },
      diff: {
        field: "Campo",
        before: "Antes",
        after: "Después",
        noChanges: "Sin cambios registrados",
      },
      export: {
        label: "Exportar CSV",
        tooltip: "Descargar auditoría filtrada como CSV",
        error: "Error al generar el export. Intente nuevamente.",
      },
    },
    creativityFieldLocks: {
      title: 'Textos impuestos',
      description: 'Campos de creatividad cuyo texto lo impone el operador: en la plataforma se muestran deshabilitados y con este texto ya cargado. Editarlo acá no requiere deploy.',
      filterAccount: 'Filtrar por cuenta',
      add: 'Nuevo texto',
      account: 'Cuenta',
      scenarioType: 'Scenario type',
      field: 'Campo',
      fieldHint: 'Sólo se listan los campos de creatividad del scenario type elegido.',
      pickScenarioFirst: 'Elegí primero un scenario type.',
      text: 'Texto impuesto',
      active: 'Activo',
      actions: 'Acciones',
      yes: 'Sí',
      no: 'No',
      empty: 'No hay textos impuestos configurados.',
      rawLength: '{n} caracteres sin resolver',
      addTitle: 'Nuevo texto impuesto',
      editTitle: 'Editar texto impuesto',
      scopeImmutable: 'La cuenta, el scenario type y el campo no se editan. Para moverlo, borrá esta fila y creá otra.',
      tokensHelp: 'La plataforma reemplaza estos tokens con los datos del template al crear la creatividad. Cualquier otro {TOKEN} se rechaza porque se enviaría literal al dispositivo.',
      satLengthWarning: 'El texto crudo tiene {n} caracteres y un opt-in S@T admite {max}. Puede quedar dentro del límite una vez resueltos los tokens — verificalo en la plataforma.',
      cancel: 'Cancelar',
      save: 'Guardar',
      saved: 'Texto impuesto guardado.',
      saveFailed: 'No se pudo guardar el texto impuesto.',
      propagationWarning: 'Al guardar se reescriben las creatividades que ya existen de este scope, resolviendo los tokens con el nombre y el precio de cada template. Corre en segundo plano y es todo o nada: si alguna falla, no se modifica ninguna.',
      savedAndEnqueued: 'Guardado. La propagación a los templates existentes quedó encolada.',
      savedEnqueueFailed: 'El texto se guardó, pero no se pudo encolar la propagación: {error}. Usá el botón de repropagar.',
      propagate: 'Repropagar a los templates existentes',
      propagateInactive: 'Un texto desactivado no se propaga',
      propagationEnqueued: 'Propagación encolada.',
      propagationFailed: 'No se pudo encolar la propagación.',
      loadFailed: 'No se pudieron cargar los textos impuestos.',
      fieldsFailed: 'No se pudieron cargar los campos del scenario type.',
      remove: 'Borrar',
      removeTitle: 'Borrar texto impuesto',
      removeConfirm: '¿Borrar el texto impuesto de {scope}?',
      removeWarning: 'El campo vuelve a ser editable en la plataforma y queda vacío en las creatividades nuevas.',
      removed: 'Texto impuesto borrado.',
      removeFailed: 'No se pudo borrar el texto impuesto.',
      errTextRequired: 'El texto es obligatorio.',
      errAccountRequired: 'Elegí una cuenta.',
      errScenarioTypeRequired: 'Elegí un scenario type.',
      errFieldRequired: 'Elegí un campo.',
    },
    myAccount: {
      menuTitle: 'Mi cuenta',
      viewDetail: 'Ver detalle',
      title: 'Mi cuenta',
      description: 'Último acceso e historial de intentos de inicio de sesión (control de auditoría 042-09).',
      lastAccessTitle: 'Último acceso',
      lastAccessUnknown: 'No hay accesos previos registrados.',
      fromIp: 'desde {ip}',
      sourceProduct: 'Dynamo',
      sourceBackoffice: 'Backoffice',
      historyTitle: 'Intentos de acceso recientes',
      empty: 'No hay intentos de acceso registrados.',
      loadFailed: 'No se pudo cargar la actividad de la cuenta.',
      columnDate: 'Fecha',
      columnResult: 'Resultado',
      columnReason: 'Motivo',
      columnDevice: 'Dispositivo',
      deviceUnknown: 'Desconocido',
      showingRange: 'Mostrando {from}-{to} de {total}',
      columnIp: 'IP',
      resultSuccess: 'Exitoso',
      resultFailure: 'Fallido',
      reasonLoginSuccess: 'Inicio de sesión exitoso',
      reasonLoginInvalidPassword: 'Contraseña incorrecta',
      reasonLoginInvalid2faCode: 'Código de verificación inválido',
      reasonLoginAccountLocked: 'Cuenta bloqueada',
      reasonLoginAccountLockedOut: 'Cuenta bloqueada (demasiados intentos)',
      reasonLoginInactiveUser: 'Cuenta inactiva',
      reasonLoginUserNotFound: 'Usuario no encontrado',
      reasonLogin2faSetupRequired: 'Falta configurar el 2FA',
      reasonLogin2faExempt: 'Ingreso sin 2FA (usuario exento)',
      reason2faEnrolledAtLogin: '2FA configurado al iniciar sesión',
      // Aviso post-login (snackbar en App.vue) — solo aparece si hubo intentos fallidos (AC3).
      noticeSingular: 'Detectamos 1 intento de acceso fallido desde tu último acceso, el {date}.',
      noticePlural: 'Detectamos {n} intentos de acceso fallidos desde tu último acceso, el {date}.',
    },
    twoFactor: {
      title: 'Autenticación de dos factores',
      subtitle: 'Sumá una capa extra de seguridad a tu cuenta.',
      disabledTitle: '2FA está deshabilitado actualmente',
      disabledDescription: 'Habilitá la autenticación de dos factores para proteger tu cuenta.',
      enable: 'Habilitar 2FA',
      enabledTitle: '2FA está habilitado',
      disable: 'Desactivar 2FA',
      chooseMethod: 'Elegí cómo querés recibir el código de verificación.',
      methodEmail: 'Email',
      methodEmailDescription: 'Recibí el código por correo electrónico.',
      methodTotp: 'App de autenticación',
      methodTotpDescription: 'Usá Google Authenticator, Authy o similar.',
      cancel: 'Cancelar',
      scanQr: 'Escaneá este código QR con tu app de autenticación.',
      manualKey: 'O ingresá esta clave manualmente',
      copy: 'Copiar',
      copied: 'Clave copiada',
      enterCode: 'Ingresá el código de 6 dígitos de tu app',
      verifyAndEnable: 'Verificar y habilitar',
      back: 'Volver',
      disableWarning: 'Esta acción reduce la seguridad de tu cuenta. Podés volver a activarlo cuando quieras.',
      enterCurrentCode: 'Ingresá tu código actual de 6 dígitos para confirmar',
      confirmDisable: 'Desactivar',
      errorGeneric: 'Ocurrió un error. Intentá de nuevo.',
      errorInvalidCode: 'Código de verificación inválido.',
      // DD-1771 — 2FA obligatorio
      requiredHint: 'Tu cuenta requiere autenticación de dos factores: no se puede desactivar.',
      forcedTitle: 'Configurá la autenticación de dos factores',
      forcedSubtitle: 'Tu cuenta requiere 2FA. Configuralo para poder ingresar.',
      emailCodeSent: 'Te enviamos un código de 6 dígitos por correo electrónico.',
      enterEmailCode: 'Ingresá el código que recibiste por correo',
      verifyAndContinue: 'Verificar y continuar',
      changeMethod: 'Cambiar método',
      backToLogin: 'Volver al login',
    },
    // DD-1771 — 2FA obligatorio por cuenta (cabecera de AccountDetail)
    accountTwoFactor: {
      label: '2FA obligatorio para los usuarios de esta cuenta',
      chipRequired: '2FA obligatorio',
      chipOptional: '2FA opcional',
      enableTitle: 'Activar 2FA obligatorio',
      enableText: '{pending} de {total} usuarios todavía no tienen 2FA: se les pedirá configurarlo en su próximo inicio de sesión.',
      disableTitle: 'Desactivar 2FA obligatorio',
      disableText: 'El 2FA pasa a ser opcional para los usuarios de esta cuenta. Quienes ya lo tienen configurado lo conservan.',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      saveError: 'No se pudo cambiar el 2FA obligatorio de la cuenta.',
      loadError: 'No se pudo cargar el estado de 2FA de la cuenta.',
      title: 'Verificación en dos pasos (2FA)',
      descriptionOn: 'Todos los usuarios asignados a esta cuenta deben usar 2FA. Quienes no lo tengan configurado lo harán en su próximo inicio de sesión.',
      descriptionOff: 'Activalo para exigir 2FA a todos los usuarios asignados a esta cuenta, nuevos y existentes.',
      usersSummary: '{total} usuarios en la cuenta · {pending} sin 2FA',
      allConfigured: 'Todos los usuarios de la cuenta tienen 2FA',
      allConfiguredNonExempt: 'Todos los usuarios no exentos tienen 2FA',
      exemptSummary: '{count} exento | {count} exentos',
      enableAction: 'Exigir 2FA',
      disableAction: 'Dejar de exigir',
      superadminOnly: 'Sólo un superadmin puede cambiarlo.',
    },
    userTwoFactorReset: {
      button: 'Resetear 2FA',
      title: 'Confirmar reseteo de 2FA',
      question: '¿Está seguro de que desea resetear la autenticación de dos factores (2FA) del usuario {username}?',
      description: 'Se eliminará la configuración actual de 2FA (app de autenticación o email). Si alguna de sus cuentas exige 2FA, deberá configurarlo de nuevo en su próximo inicio de sesión.',
      cancel: 'Cancelar',
      confirm: 'Resetear 2FA',
    },
    accountDetail: {
      title: 'Configuración de la cuenta',
      backToAccounts: 'Volver a Cuentas',
      loading: 'Cargando la configuración de la cuenta...',
      error: 'Error al cargar la configuración de la cuenta',
      variables: 'Variables',
      smppConnections: 'Conexiones SMPP',
      scenarioTypes: 'Tipos de escenario',
      userProfiles: 'Usuarios y perfiles',
      commercialAdmins: 'Administradores comerciales',
      operationalAdmins: 'Administradores operativos',
      paymentMethods: 'Medios de pago',
      advertiserPaymentMethods: 'Medios de pago de anunciantes',
      campaignCategories: 'Categorías de la cuenta',
      blacklistSecondAction: 'Segunda acción de lista negra',
    },
    channelPrices: {
      title: 'Precios de canales',
      description: 'Configurá el precio unitario por canal facturable para cada cuenta. Los precios se versionan por fecha: cambiar un precio nunca sobrescribe el histórico.',
      account: 'Cuenta',
      selectAccount: 'Elegí una cuenta para ver y configurar los precios.',
      channel: 'Canal',
      currentPrice: 'Precio actual',
      currency: 'Moneda',
      validFrom: 'Vigente desde',
      actions: 'Acciones',
      notSet: '— sin configurar —',
      changePrice: 'Cambiar precio',
      history: 'Historial',
      hideHistory: 'Ocultar historial',
      noHistory: 'No hay precios anteriores para este canal.',
      price: 'Precio',
      validTo: 'Vigente hasta',
      current: '— vigente —',
      changePriceTitle: 'Cambiar precio — {channel}',
      changePriceHelper: 'Crea una fila de precio nueva y cierra la vigente el día anterior. El precio anterior queda disponible para reportes de meses pasados.',
      newPrice: 'Precio nuevo',
      cancel: 'Cancelar',
      save: 'Guardar',
      priceUpdated: 'Precio actualizado',
      priceSaveFailed: 'No se pudo guardar el precio',
      selectAccountFirst: 'Elegí una cuenta primero',
      errPriceNonNegative: 'El precio tiene que ser un número mayor o igual a cero',
      errCurrency: 'La moneda tiene que ser un código de 3 letras (por ejemplo USD)',
      errValidFrom: 'La fecha "Vigente desde" tiene que estar en formato YYYY-MM-DD',
      mode: 'Modalidad',
      modeFixed: 'Fijo',
      modeVariable: 'Variable',
      modeTiered: 'Por baches',
      helpFixed: 'Un único precio por envío. Costo total = envíos × precio.',
      helpVariable: 'El volumen total del mes cae en un tramo y todos los envíos se cobran al precio de ese tramo.',
      helpTiered: 'Cada tramo se cobra a su propio precio, acumulativo sobre el volumen del mes.',
      tiersSummary: '{n} tramos',
      tiersDetail: 'Tramos configurados:',
      tierFrom: 'Desde (unidades)',
      tierPrice: 'Precio',
      addTier: 'Agregar tramo',
      errAtLeastOneTier: 'Configurá al menos un tramo',
      errFirstTierZero: 'El primer tramo tiene que empezar en 0',
      errTierFromInteger: 'El inicio del tramo tiene que ser un entero no negativo',
      errTierPriceNonNegative: 'El precio del tramo tiene que ser mayor o igual a cero',
      errTierIncreasing: 'Los tramos deben ser estrictamente crecientes por unidades'
    }
  },

  en: {
    common: {
      // Navigation
      dashboard: "Dashboard",
      campaigns: "Campaigns",
      templates: "Templates",
      categories: "Categories",
      advertisers: "Advertisers",
      accounts: "Accounts",
      account: "Account",
      users: "Users",
      profiles: "Profiles",
      operators: "Operators",
      countries: "Countries",
      scenarioTypes: "Scenario Types",
      services: "Services",
      auditLog: "Audit Log",

      // Actions
      create: "Create",
      edit: "Edit",
      update: "Update",
      delete: "Delete",
      view: "View",
      save: "Save",
      cancel: "Cancel",
      close: "Close",
      back: "Back",
      search: "Search",
      filter: "Filter",
      clearFilters: "Clear Filters",
      confirmDelete: "Confirm Delete",
      actions: "Actions",
      deleteSelected: "Delete Selected",
      clearSelection: "Clear Selection",
      clearAll: "Clear All",

      // Status (column/label: use common.statusLabel; options: common.status.active, etc.)
      status: {
        active: "Active",
        inactive: "Inactive",
        pending: "Pending",
        suspended: "Suspended",
        enabled: "Enabled",
        disabled: "Disabled",
      },
      statusLabel: "Status",

      // Status object for nested access
      statusTypes: {
        active: "Active",
        inactive: "Inactive",
        pending: "Pending",
        suspended: "Suspended",
        enabled: "Enabled",
        disabled: "Disabled",
      },

      // Dates
      created: "Created",
      modified: "Modified",

      // Validation
      required: "This field is required",
      invalidEmail: "Invalid email",
      invalidPhone: "Invalid phone number",
      invalidUrl: "Invalid URL",
      positiveValue: "Value must be positive",
      selectUser: "Must select a user",
      selectVariable: "Must select a variable",
      msisdnFormat: "MSISDN must contain between 7 and 15 digits",
      positive: "Value must be positive",
      positiveNumber: "Must be a positive number",
      validNumber: "Must be a valid number",

      // Messages
      loading: "Loading...",
      noData: "No data available",
      none: "None",
      error: "Error",
      success: "Success",
      accessDenied: "Access Denied",
      yes: "Yes",
      no: "No",

      // Status (direct access)
      active: "Active",
      inactive: "Inactive",

      // Error messages
      errorMessages: {
        saving: "Error saving",
        loading: "Error loading",
        deleting: "Error deleting",
        updating: "Error updating",
        creating: "Error creating",
      },

      // Validation nested object
      validation: {
        required: "This field is required",
        email: "Must be a valid email",
        minLength: "Must be at least {min} characters",
        maxLength: "Cannot exceed {max} characters",
        numeric: "Must be a valid number",
        url: "Must be a valid URL",
        msisdnFormat: "MSISDN must contain between 7 and 15 digits",
      },
      backendAccessRequired: "Backend access is required to use this application",
      retry: "Retry",
      currentLanguage: "Current Language",
      default: "Default",
      native: "Native",
      browserLanguage: "Browser Language",
      browserDetected: "Detected by Browser",
      // Pagination
      itemsPerPage: "Items per page",
      pageText: "Page",
      page: "Page",
      of: "of",
      nextPage: "Next page",
      prevPage: "Previous page",
      firstPage: "First page",
      lastPage: "Last page",
      id: "ID",
      locale: "en-US",
      all: "All",
      pageOf: "{page} of {total}",
      pageRange: "{start}-{end} of {total}",
      notAvailable: "N/A",
      showing: "Showing",
      items: "items",
    },

    // Errors
    errors: {
      loadingCommercialAdmins: "Error loading commercial administrators",
      loadingOperationalAdmins: "Error loading operational administrators",
      loadingUsers: "Error loading available users",
      loadingBlacklistEntries: "Error loading blacklist entries",
      loadingValidators: "Error loading validators",
      loadingData: "Error loading data",
      loadingTemplate: "Error loading template",
      loadingAccount: "Error loading account",
      savingAdmin: "Error saving administrator",
      savingValidator: "Error saving validator",
      savingTemplate: "Error saving template",
      deletingAdmin: "Error deleting administrator",
      deletingValidator: "Error deleting validator",
      openingModal: "Error opening modal",
      msisdnAlreadyExists: "This MSISDN is already in the blacklist for this account",
      invalidMsisdnFormat: "Invalid MSISDN format",
      addingMsisdnToBlacklist: "Error adding MSISDN to blacklist",
      deletingMsisdnFromBlacklist: "Error deleting MSISDN from blacklist",
      loadingOperators: "Error loading operators",
    },

    // Campaigns
    campaigns: {
      title: "Campaigns",
      subtitle: "Manage system campaigns",
      createTitle: "Create Campaign",
      createSubtitle: "Create a new campaign",
      editTitle: "Edit Campaign",
      editSubtitle: "Modify campaign data",
      name: "Name",
      type: "Type",
      account: "Account",
      advertiser: "Advertiser",
      category: "Category",
      subcategory: "Subcategory",
      status: "Status",
      price: "Price",
      startDate: "Start Date",
      endDate: "End Date",
      audience: "Audience",
      retryType: "Retry Type",
      engineImage: "Engine Image",
      createSuccess: "Campaign created successfully",
      updateSuccess: "Campaign updated successfully",
      deleteSuccess: "Campaign deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the campaign "{name}"?',
      details: "Details",
      basicInfo: "Basic Information",
      campaignStatus: "Status",
      notSet: "Not set",
      quickActions: "Quick Actions",
      editCampaign: "Edit Campaign",
      viewStatistics: "View Statistics",
      mtAmount: "MT Amount",
    },

    // Campaign Form
    campaignForm: {
      basicInfo: "Basic Information",
      actions: "Actions",
      saveCampaign: "Save Campaign",
      backToList: "Back to List",
      accountInfo: "Account Information",
      schedule: "Schedule",
      startDateTime: "Start Date and Time",
      endDateTime: "End Date and Time",
      finishedDateTime: "Finished Date and Time",
      advancedConfig: "Advanced Configuration",
    },

    // Templates
    templates: {
      title: "Templates",
      subtitle: "Manage system templates",
      createTitle: "Create Template",
      createSubtitle: "Create a new template",
      editTitle: "Edit Template",
      editSubtitle: "Modify template data",
      name: "Name",
      status: "Status",
      account: "Account",
      advertiser: "Advertiser",
      category: "Category",
      subcategory: "Subcategory",
      price: "Price",
      description: "Description",
      createSuccess: "Template created successfully",
      updateSuccess: "Template updated successfully",
      deleteSuccess: "Template deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the template "{name}"?',
      basicInfo: "Basic Information",
      statusApproved: "Approved",
      statusPending: "Pending",
      statusRejected: "Rejected",
      statusArchived: "Archived",
      updatedSuccessfully: "Template updated successfully",
      createdSuccessfully: "Template created successfully",
      // Template fields
      fields: {
        name: "Name",
        user: "User",
        category: "Category",
        subcategory: "Subcategory",
        account: "Account",
        advertiser: "Advertiser",
        price: "Price",
        status: "Status",
      },
      // Template status
      statusTypes: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
      },
    },

    // MSISDN Validators
    msisdnValidator: {
      title: "MSISDN Validator",
      create: "Create Validator",
      edit: "Edit Validator",
      createDescription: "Create a new MSISDN validator for a specific country",
      editDescription: "Modify MSISDN validator configuration",
      loading: "Loading validator...",
      validatorInfo: "Validator Information",
      countryCode: "Country Code",
      countryCodeHint: "Numeric country code (e.g: 54 for Argentina)",
      lengthRange: "Length Range",
      minLength: "Minimum Length",
      maxLength: "Maximum Length",
      action: "Action",
      addCountryCode: "Add Country Code",
      trimCountryCode: "Trim Country Code",
      maxLengthError: "Maximum length must be greater than or equal to {minlen}",
      createdSuccessfully: "Validator created successfully",
      updatedSuccessfully: "Validator updated successfully",
    },

    msisdnValidators: {
      title: "MSISDN Validators",
      description: "Manage phone number validation rules by country",
      newValidator: "New Validator",
      searchByCountryCode: "Search by country code",
      filterByAction: "Filter by action",
      addCountryCode: "Add code",
      trimCountryCode: "Trim code",
      addCode: "Add code",
      trimCode: "Trim code",
      countryCode: "Country Code",
      showingResults: "Showing {filtered} of {total} results",
      lengthRange: "Length Range",
      action: "Action",
      autocomplete: "Autocomplete",
      createTitle: "Create Validator",
      editTitle: "Edit Validator",
      minLength: "Minimum Length",
      maxLength: "Maximum Length",
      deleteConfirm: 'Are you sure you want to delete the validator for country "{countryCode}"?',
      createSuccess: "Validator created successfully",
      updateSuccess: "Validator updated successfully",
      deleteSuccess: "Validator deleted successfully",
      createdSuccessfully: "Validator created successfully",
      updatedSuccessfully: "Validator updated successfully",
      deletedSuccessfully: "Validator deleted successfully",
    },

    // Categories
    categories: {
      title: "Categories",
      subtitle: "Manage categories and subcategories",
      createTitle: "Create Category",
      createSubtitle: "Create a new category",
      editTitle: "Edit Category",
      editSubtitle: "Modify category data",
      information: "Category Information",
      name: "Name",
      subcategories: "Subcategories",
      svgId: "SVG ID",
      createSuccess: "Category created successfully",
      updateSuccess: "Category updated successfully",
      deleteSuccess: "Category deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the category "{name}"?',
      subcategoryCreateSuccess: "Subcategory created successfully",
      subcategoryUpdateSuccess: "Subcategory updated successfully",
      subcategoryDeleteSuccess: "Subcategory deleted successfully",
      fields: {
        name: "Name",
        description: "Description",
        subcategories: "Subcategories",
        svgId: "SVG ID",
      },
    },

    // Advertisers
    advertisers: {
      title: "Advertisers",
      subtitle: "Manage system advertisers",
      createTitle: "Create Advertiser",
      createSubtitle: "Create a new advertiser",
      editTitle: "Edit Advertiser",
      editSubtitle: "Modify advertiser data",
      name: "Name",
      createSuccess: "Advertiser created successfully",
      updateSuccess: "Advertiser updated successfully",
      deleteSuccess: "Advertiser deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the advertiser "{name}"?',
    },

    subscriptionServices: {
      title: "Subscription services",
      serviceName: "Name",
      account: "Account",
      advertiser: "Advertiser",
      price: "Price",
      activations: "Activations",
      additionalActivations: "Additional activations",
      filterAccount: "Filter by account",
      filterAdvertiser: "Filter by advertiser",
      editTitle: "Edit activations",
      updateSuccess: "Service updated successfully",
      noData: "No subscription services",
      noDataFiltered: "No results match the current filters",
      nonNegativeInteger: "Must be an integer greater than or equal to 0",
    },

    // Accounts
    accounts: {
      title: "Accounts",
      subtitle: "Manage system accounts",
      createTitle: "Create Account",
      createSubtitle: "Create a new account",
      editTitle: "Edit Account",
      editSubtitle: "Modify account data",
      name: "Name",
      advertiser: "Advertiser",
      balance: "Balance",
      currency: "Currency",
      timezone: "Timezone",
      contactName: "Contact Name",
      contactEmail: "Contact Email",
      contactPhone: "Contact Phone",
      website: "Website",
      address: "Address",
      city: "City",
      state: "State/Province",
      zipCode: "Zip Code",
      country: "Country",
      description: "Description",
      taxId: "Tax ID",
      businessId: "Business ID",
      basicInfo: "Basic Information",
      contactInfo: "Contact Information",
      addressInfo: "Address Information",
      additionalInfo: "Additional Information",
      location: "Location",
      commercialAdmins: "Commercial Admins",
      operationalAdmins: "Operational Admins",
      paymentMethods: "Payment Methods",
      paymentMethod: "Payment Method",
      accountNumber: "Account Number",
      createSuccess: "Account created successfully",
      updateSuccess: "Account updated successfully",
      deleteSuccess: "Account deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the account "{name}"?',

      // Account Form
      form: {
        editTitle: "Edit Account",
        createTitle: "Create New Account",
        editSubtitle: "Modify account information",
        createSubtitle: "Complete the information to create a new account",
        basicInfo: "Basic Information",
        accountName: "Account Name",
        accountType: "Account Type",
        operator: "Operator",
        msisdnValidator: "MSISDN Validator",
        active: "Active",
        antiSpamConfig: "Anti-spam Configuration",
        antiSpamType: "Anti-spam Type",
        impressionsAmount: "Impressions Amount",
        perDays: "Per Days",
        loadingAccountInfo: "Loading account information...",
        updateSuccess: "Account updated successfully",
        createSuccess: "Account created successfully",
        errorLoadingData: "Error loading data: {message}",
        errorLoadingAccount: "Error loading account: {message}",
        errorSavingAccount: "Error saving account: {message}",
        tooltip: {
          msisdnValidator: "MSISDN Validator: Defines validation rules for phone numbers by country.",
          countryCode: "Country code: Identifies the country",
          length: "Length: Range of allowed digits",
          action: "Action: How to handle the country code",
          addCode: "Add code",
          trimCode: "Trim code",
          code: "Code: {code} | Length: {min}-{max}",
        },
      },
    },

    // Accounts List
    accountsList: {
      title: "Accounts",
      newAccount: "New Account",
      filters: "Filters",
      clearFilters: "Clear Filters",
      search: "Search",
      searchPlaceholder: "Account name or ID...",
      status: "Status",
      all: "All",
      active: "Active",
      inactive: "Inactive",
      operator: "Operator",
      results: "results",
      result: "result",
      noResultsWithFilters: "No accounts found matching the applied filters",
      accountType: "Account Type",
      antiSpamType: "Anti-spam Type",
      impressions: "Impressions",
      perDays: "Per Days",
      configure: "Configure",
      deactivate: "Deactivate",
      activate: "Activate",
      confirmDeactivation: "Confirm deactivation",
      confirmDeactivationMessage: 'Are you sure you want to deactivate account "{name}"?',
      confirmActivation: "Confirm activation",
      confirmActivationMessage: 'Are you sure you want to activate account "{name}"?',
      note: "Note",
      deactivationNote: "The account will be deactivated but not deleted from the system.",
    },

    // Account Components
    account: {
      // Blacklist Second Action
      blacklistSecondAction: "Blacklist Second Action",
      addMsisdn: "Add MSISDN",
      deleteMsisdn: "Delete MSISDN",
      addMsisdnToBlacklist: "Add MSISDN to Blacklist",
      msisdn: "MSISDN",
      msisdnPlaceholder: "E.g: 1234567890",
      msisdnHint: "Enter phone number without spaces or dashes",
      creationDate: "Creation Date",
      confirmDeleteMsisdn: "Are you sure you want to delete MSISDN {msisdn} from the blacklist?",
      msisdnAddedSuccessfully: "MSISDN added to blacklist successfully",
      msisdnDeletedSuccessfully: "MSISDN deleted from blacklist successfully",

      // Tooltip
      howItWorks: "How does it work?",
      blacklistDescription1:
        "This MSISDN list will NOT receive second action. All changes take up to 1 hour to update in the backend.",
      blacklistDescription2:
        "When we receive the event to process the SA, we filter by this MSISDN list. If it's not in the list, we queue and then execute the SA.",

      // Commercial Admins
      commercialAdmins: "Commercial Administrators",
      addCommercial: "Add Commercial",
      addCommercialAdmin: "Add Commercial Administrator",
      deleteCommercial: "Delete commercial",
      confirmDeleteAdmin: 'Are you sure you want to delete administrator "{name}" ({username}) from this account?',
      adminAddedSuccessfully: "Administrator added successfully",
      adminDeletedSuccessfully: "Administrator deleted successfully",

      // Operational Admins
      operationalAdmins: "Operational Administrators",
      addOperational: "Add Operational",
      addOperationalAdmin: "Add Operational Administrator",
      deleteOperational: "Delete operational",

      // Account Variables
      accountVariables: "Account Variables",
      editVariable: "Edit Variable",
      addVariable: "Add Variable",
      deleteVariable: "Delete variable",
      selectedVariable: "Selected variable",
      defaultValue: "Default value",
      variable: "Variable",
      accountValue: "Account Value",
      accountValuePlaceholder: "Enter the value for this account",

      // Common fields
      user: "User",
      username: "Username",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
    },

    // Users
    users: {
      title: "Users",
      subtitle: "Manage system users",
      createTitle: "Create User",
      createSubtitle: "Create a new user",
      createUser: "Create User",
      editTitle: "Edit User",
      editSubtitle: "Modify user data",
      editUser: "Edit User",
      username: "Username",
      email: "Email",
      firstname: "First Name",
      lastname: "Last Name",
      fullName: "Full Name",
      role: "Role",
      admin: "Administrator",
      manager: "Manager",
      operator: "Operator",
      user: "User",
      unknown: "Unknown",
      enable: "Enable",
      disable: "Disable",
      password: "Password",
      confirmPassword: "Confirm Password",
      position: "Position",
      defaultLanguage: "Default Language",
      selectedAccount: "Selected Account",
      landingPage: "Landing Page",
      backendAccess: "Backend Access",
      basicInfo: "Basic Information",
      passwordInfo: "Password Information",
      roleAndStatus: "Role and Status",
      additionalInfo: "Additional Information",
      associations: "Associations",
      userProfiles: "User Profiles",
      account: "Account",
      profile: "Profile",
      invalidUsername: "Username must be 3-20 alphanumeric characters",
      passwordMinLength: "Password must be at least 6 characters",
      passwordMismatch: "Passwords do not match",
      enableSuccess: "User enabled successfully",
      disableSuccess: "User disabled successfully",
      createSuccess: "User created successfully",
      updateSuccess: "User updated successfully",
      saveSuccess: "User saved successfully",
      deleteSuccess: "User deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the user "{name}"?',
      changePassword: "Change Password",
      passwordUpdateSuccess: "Password updated and emailed to the user",
      passwordUpdateSuccessNoEmail: "Password updated. The notification email could not be sent",
      temporaryPasswordNotice: "The user will be required to set a new password on their next login. This temporary password expires in 30 days.",
      temporaryPasswordEmailNotice: "It will be emailed to {email}.",
      createSuccessEmailSent: "User created. The welcome email was sent to {email}",
      createSuccessNoEmail: "User created. The welcome email could not be sent: resend it from Security",
      welcomeEmailCreateNotice: "When the user is created, they will receive an email with their username, this temporary password and the sign-in link. They must change it on first login; it expires in 30 days.",
      welcomeEmailTitle: "Welcome email",
      welcomeEmailDescription: "If the user did not receive the email with their sign-in details, you can resend it. A new temporary password is generated and the previous one stops working.",
      welcomeEmailResend: "Resend welcome email",
      welcomeEmailConfirmTitle: "Resend welcome email",
      welcomeEmailConfirmText: "A new temporary password will be generated and sent to {email}. The previous password will stop working.",
      welcomeEmailResent: "Welcome email resent to {email}",
      welcomeEmailResentNoEmail: "A new password was generated but the email could not be sent. Try again in a few minutes.",
      welcomeEmailNoEmail: "The user has no email address",
      welcomeEmailAlreadyLoggedInTitle: "The welcome email cannot be resent",
      welcomeEmailAlreadyLoggedInText: "The user has already signed in to the platform, so the welcome email cannot be resent. We recommend resetting their password: they will receive an email with a temporary password.",
      welcomeEmailResetPassword: "Reset password",
      welcomeEmailError: "The welcome email could not be resent",

      // User fields
      fields: {
        username: "Username",
        email: "Email",
        firstname: "First Name",
        lastname: "Last Name",
        status: "Status",
        advertiser: "Advertiser",
        position: "Position",
        defaultLanguage: "Default Language",
        backendAccess: "Backend Access",
        subdomainAccess: "Subdomain Access",
        landingPage: "Landing Page",
        selectedAccount: "Selected Account",
        password: "Password",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",
      },
    },

    // Profiles
    profiles: {
      title: "Profiles",
      subtitle: "Manage profiles and privileges",
      createTitle: "Create Profile",
      createSubtitle: "Create a new profile",
      editTitle: "Edit Profile",
      editSubtitle: "Modify profile data",
      editProfile: "Edit Profile",
      name: "Name",
      description: "Description",
      scope: "Scope",
      fields: {
        name: "Name",
        scope: "Scope",
      },
      scopeOptions: {
        accountId: "Account ID",
        advertiserId: "Advertiser ID",
      },
      privileges: "Privileges",
      privilegesDescription: "Manage privileges assigned to this profile",
      privilegeName: "Privilege Name",
      privilegeDescription: "Description",
      privilegeStatus: "Status",
      privilegeToggle: "Enable/Disable",
      noPrivilegesFound: "No privileges found",
      noPrivilegesDescription: "No privileges available to display",
      nameRequired: "Profile name is required",
      global: "Global",
      account: "Account",
      advertiser: "Advertiser",
      managePrivileges: "Manage Privileges",
      privilegesUpdateSuccess: "Privileges updated successfully",
      createSuccess: "Profile created successfully",
      updateSuccess: "Profile updated successfully",
      deleteSuccess: "Profile deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the profile "{name}"?',
      messages: {
        created: "Profile created successfully",
        updated: "Profile updated successfully",
        deleted: "Profile deleted successfully",
      },
      reports: "Reports",
      manageReports: "Manage Reports",
      reportsDescription: "Manage reports assigned to this profile",
      availableReports: "Available Reports",
      assignedReports: "Assigned Reports",
      noReportsAssigned: "No reports assigned",
      noReportsAvailable: "No reports available",
      addReport: "Add Report",
      removeReport: "Remove Report",
      reportName: "Report Name",
      reportComponent: "Component",
      reportsUpdateSuccess: "Profile reports updated successfully",
      reportAddedSuccess: "Report added to profile successfully",
      reportRemovedSuccess: "Report removed from profile successfully",
    },

    // Operators
    operators: {
      title: "Operators",
      subtitle: "Manage system operators",
      createTitle: "Create Operator",
      createSubtitle: "Create a new operator",
      editTitle: "Edit Operator",
      editSubtitle: "Modify operator data",
      name: "Name",
      code: "Code",
      description: "Description",
      phoneCode: "Phone Code",
      website: "Website",
      supportEmail: "Support Email",
      notes: "Notes",
      invalidCode: "Code must be 2-10 alphanumeric characters",
      invalidPhoneCode: "Invalid phone code",
      enable: "Enable",
      disable: "Disable",
      enableSuccess: "Operator enabled successfully",
      disableSuccess: "Operator disabled successfully",
      createSuccess: "Operator created successfully",
      updateSuccess: "Operator updated successfully",
      deleteSuccess: "Operator deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the operator "{name}"?',

      // Operator fields
      fields: {
        name: "Name",
        country: "Country",
        status: "Status",
        active: "Active",
        maxImpactsPerUser: "Max Impacts per User",
        maxImpactsPeriod: "Max Impacts Period",
      },
    },

    // Countries
    countries: {
      title: "Countries",
      subtitle: "Manage system countries",
      createTitle: "Create Country",
      createSubtitle: "Create a new country",
      editTitle: "Edit Country",
      editSubtitle: "Modify country data",
      name: "Name",
      code: "Code",
      phoneCode: "Phone Code",
      currency: "Currency",
      timezone: "Timezone",
      language: "Language",
      description: "Description",
      active: "Active",
      defaultCountry: "Default Country",
      invalidCountryCode: "Code must be 2-3 uppercase letters",
      invalidPhoneCode: "Invalid phone code",
      invalidTimezone: "Invalid timezone format (e.g., UTC-5)",
      invalidLanguage: "Invalid language code (e.g., es)",
      createSuccess: "Country created successfully",
      updateSuccess: "Country updated successfully",
      deleteSuccess: "Country deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the country "{name}"?',
      searchPlaceholder: "Name or country code...",
      noResultsWithFilters: "No countries found with applied filters",
      noDataAvailable: "No countries available",
      resultsCount: "{count} result{count, plural, =1 {} other {s}}",
      countryCodeHint: "2-letter code (e.g: AR, US)",
      timezoneHint: "Timezone (e.g: America/Argentina/Buenos_Aires)",
      phoneCodeHint: "Phone code (e.g: 54)",
      mccHint: "Mobile Country Code",
      geolocationHint: "Geolocation information in JSON format",

      // Country fields
      fields: {
        name: "Name",
        countrycode: "Country Code",
        timezone: "Timezone",
        phonecode: "Phone Code",
        mcc: "MCC",
        geolocation: "Geolocation",
      },

      // Validation messages
      validation: {
        countryCodeFormat: "Country code must be 2 uppercase letters",
        phoneCodePositive: "Phone code must be a positive number",
        mccPositive: "MCC must be a positive number",
        invalidJsonFormat: "Invalid JSON format in geolocation",
      },
    },

    // Scenario Types
    scenarioTypes: {
      title: "Scenario Types",
      subtitle: "Manage scenario types",
      createTitle: "Create Scenario Type",
      createSubtitle: "Create a new scenario type",
      editTitle: "Edit Scenario Type",
      editSubtitle: "Modify scenario type data",
      name: "Name",
      description: "Description",
      category: "Category",
      variables: "Variables",
      basic: "Basic",
      advanced: "Advanced",
      custom: "Custom",
      manageVariables: "Manage Variables",
      addVariable: "Add Variable",
      variableName: "Variable Name",
      defaultValue: "Default Value",
      variablesUpdateSuccess: "Variables updated successfully",
      createSuccess: "Scenario type created successfully",
      updateSuccess: "Scenario type updated successfully",
      deleteSuccess: "Scenario type deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the scenario type "{name}"?',
      status: "Status",
      templateFile: "Template File",
      channelId: "Channel ID",
      channelName: "Channel Name",
      active: "Active",
      hasMenu: "Has Menu",
      orderBy: "Order By",

      // Form fields
      fields: {
        name: "Name",
        templateFile: "Template File",
        channelId: "Channel ID",
        active: "Active",
        hasMenu: "Has Menu",
        orderBy: "Order By",
      },
    },

    // Account User Profiles
    accountUserProfiles: {
      title: "Account Users and Profiles",
      subtitle: "Manage users and their profiles for this account",
      addUser: "Add User",
      editUserProfiles: "Edit User Profiles",
      selectUser: "Select User",
      selectProfiles: "Select Profiles",
      user: "User",
      profiles: "Profiles",
      addSuccess: "User added successfully",
      updateSuccess: "User profiles updated successfully",
      removeProfileSuccess: "Profile removed successfully",
      removeUserSuccess: "User removed from account successfully",
      removeUserConfirm: "Are you sure you want to remove {name} from this account?",
    },

    // Account Scenario Types
    accountScenarioTypes: {
      title: "Account Scenario Types",
      subtitle: "Manage scenario types for this account",
      addTitle: "Add Scenario Type",
      addSubtitle: "Add a new scenario type to this account",
      editTitle: "Edit Scenario Type",
      editSubtitle: "Modify the scenario type for this account",
      channel: "Channel",
      channelDescription: "Channel determines which scenario types are available",
      scenarioType: "Scenario Type",
      scenarioTypeDescription: "Scenario types available for the selected channel",
      alias: "Alias (Optional)",
      aliasHint: "Allows customizing the scenario name for this account",
      active: "Active",
      additionalConfig: "Additional Configuration",
      step1: "Step 1: Select Channel",
      step2: "Step 2: Select Scenario Type",
      step3: "Step 3: Additional Configuration",
      clearSelection: "Clear Selection",
      completeRequiredFields: "Complete required fields",
      save: "Save",
      cancel: "Cancel",
      addSuccess: "Scenario type added successfully",
      updateSuccess: "Scenario type updated successfully",
      deleteSuccess: "Scenario type deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the scenario type "{name}" ({alias}) from this account?',
      noAlias: "No alias",
      manageVariables: "Manage Variables",
      variablesForCampaigns: "Variables for Campaigns",
      variablesForEvents: "Variables for Events",
      customVariablesForCampaigns: "Custom Variables for Campaigns",
      customVariablesForEvents: "Custom Variables for Events",
      customizeVariableValues: "Customize variable values for this scenario type",
      customizeVariableValuesEvents: "Customize variable values for events of this scenario type",
      variable: "Variable",
      defaultValue: "Default Value",
      status: "Status",
      actions: "Actions",
      saved: "Saved",
      notSaved: "Not Saved",
      deleteVariable: "Delete Variable",
      saveVariable: "Save Variable",
      variableDeleted: "Variable deleted successfully",
      variableCreated: "Variable created successfully",
      variableUpdated: "Variable updated successfully",
      close: "Close",
      account: "Account",
    },

    // Subcategories
    subcategories: {
      title: "Subcategories",
      createTitle: "Create Subcategory",
      editTitle: "Edit Subcategory",
      name: "Name",
      category: "Category",
      svgId: "SVG ID",
      add: "Add",
      noData: "No subcategories available",
      placeholders: {
        name: "Subcategory name...",
      },
      fields: {
        name: "Name",
      },
      createSuccess: "Subcategory created successfully",
      updateSuccess: "Subcategory updated successfully",
      deleteSuccess: "Subcategory deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the subcategory "{name}"?',
      error: {
        loading: "Error loading subcategories",
        creating: "Error creating subcategory",
        deleting: "Error deleting subcategory",
      },
    },

    // Dashboard
    dashboard: {
      title: "Dashboard",
      totalCampaigns: "Total Campaigns",
      activeCampaigns: "Active Campaigns",
      totalRevenue: "Total Revenue",
      avgPrice: "Average Price",
      quickActions: "Quick Actions",
      createCampaign: "Create Campaign",
      createTemplate: "Create Template",
      createUser: "Create User",
      createAccount: "Create Account",
      systemStatus: "System Status",
      apiServer: "API Server",
      online: "Online",
      database: "Database",
      cache: "Cache",
      performance: "Performance",
      responseTime: "Response Time",
      uptime: "Uptime",
      lastUpdate: "Last Update",
    },

    // Campaigns List
    campaignsList: {
      title: "Campaigns",
      newCampaign: "New Campaign",
      createTitle: "Create Campaign",
      editTitle: "Edit Campaign",
      filters: "Filters",
      clearFilters: "Clear Filters",
      search: "Search",
      searchPlaceholder: "Name, description...",
      status: "Status",
      account: "Account",
      advertiser: "Advertiser",
      name: "Name",
      category: "Category",
      results: "results",
      result: "result",
      noCampaigns: "No campaigns found",
      loading: "Loading campaigns...",
      error: "Error loading campaigns",
      viewDetails: "View Details",
      edit: "Edit",
      delete: "Delete",
      confirmDelete: 'Are you sure you want to mark campaign "{name}" from account "{account}" as deleted?',
      createSuccess: "Campaign created successfully",
      updateSuccess: "Campaign updated successfully",
      deleteSuccess: "Campaign marked as deleted successfully",
      deleteError: "Error marking campaign as deleted",
    },

    // Account Detail
    accountDetail: {
      title: "Account Configuration",
      backToAccounts: "Back to Accounts",
      loading: "Loading account configuration...",
      error: "Error loading account configuration",
      variables: "Variables",
      smppConnections: "SMPP Connections",
      scenarioTypes: "Scenario Types",
      userProfiles: "Users and Profiles",
      commercialAdmins: "Commercial Administrators",
      operationalAdmins: "Operational Administrators",
      paymentMethods: "Payment Methods",
      advertiserPaymentMethods: "Advertiser Payment Methods",
      campaignCategories: "Account Categories",
      blacklistSecondAction: "Blacklist Second Action",
    },

    smppConnections: {
      title: "SMPP Connections",
      description: "Manage account SMPP connections",
      addConnection: "Add Connection",
      createConnection: "Create Connection",
      editConnection: "Edit Connection",
      noConnections: "No connections available",
      name: "Name",
      url: "URL",
      urlSms: "SMS URL",
      urlFlashsms: "Flash SMS URL",
      urlStatus: "Status URL",
      throughput: "Throughput",
      throughputHint: "Messages per second",
      messagesPerSecond: "msg/s",
      status: "Status",
      maxQueue: "Max Queue",
      usleepPerMsgSent: "Usleep per Message",
      checkEachNSecs: "Check every N seconds",
      checkStatus: "Check Status",
      statusResults: "Status Results",
      testsTitle: "SMPP Connection Tests",
      runTest: "Run Test",
      testType: "Test Type",
      msisdn: "MSISDN",
      message: "Message",
      senderId: "Sender ID",
      messageCount: "Messages Count",
      lastTestResult: "Last Test Result",
      testHistory: "Test History",
      testStatusSuccess: "Success",
      testStatusFailed: "Failed",
      mockNotice: "This is a client-side mock test. Backend integration is pending.",
      noTests: "No tests executed yet",
      testDialog: {
        tabs: {
          fullExecution: "Full test execution",
          unitTests: "Unit tests",
        },
        fullExecution: {
          title: "Connection validation tests:",
          presetsTitle: "Preset tests",
          presets: {
            sms: {
              title: "Send an SMS",
              subtitle: "Sends a test SMS with text 'Test SMS'",
            },
            satPingPorOn: {
              title: "Send a SAT PING with PoR: ON",
              subtitle: "SAT mode PING, PoR ON",
            },
            satPingPorOff: {
              title: "Send a SAT PING with PoR: OFF",
              subtitle: "SAT mode PING, PoR OFF",
            },
            satMsgCapture: {
              title: "Send a SAT MSG (capture)",
              subtitle:
                'SAT mode MSG. Message: "This message is a test. Please capture the screen and share the results"',
            },
          },
        },
        unitTests: {
          sendType: {
            sms: "SMS",
            flashSms: "FlashSMS",
            sat: "SAT",
          },
          dlrLabel: "DLR",
          on: "On",
          off: "Off",
          satModeLabel: "SAT mode",
          satModePing: "PING",
          satModeMsg: "MSG",
          porLabel: "PoR",
          true: "True",
          false: "False",
          satMsgLabel: "SAT MSG",
        },
        smsHint: {
          invalidCharsRemoved: "invalid characters removed",
          truncatedToLimit: "truncated to the maximum allowed",
        },
      },
      createSuccess: "Connection created successfully",
      updateSuccess: "Connection updated successfully",
      deleteSuccess: "Connection deleted successfully",
      deleteConfirm: 'Are you sure you want to delete the connection "{name}"?',
      errorLoading: "Error loading connections",
      errorCheckingStatus: "Error checking connection status",
    },

    accountCampaignCategories: {
      title: "Account Categories",
      description: "Manage the available account categories for this account",
      categoryName: "Category Name",
      status: "Status",
      toggleSuccess: "Category updated successfully",
      noCategories: "No categories available",
      searchPlaceholder: "Search category...",
    },

    accountPaymentMethods: {
      title: "Account Payment Methods",
      addPaymentMethod: "Add Payment Method",
      editPaymentMethod: "Edit Payment Method",
      selectPaymentMethod: "Select Payment Method",
      priority: "Priority",
      priorityMin: "Priority must be greater than or equal to 0",
      paymentMethod: "Payment Method",
      paymentMethodRequired: "You must select a payment method",
      deleteConfirmation: 'Are you sure you want to delete the payment method "{name}" from this account?',
      errorLoading: "Error loading payment methods",
      errorLoadingAvailable: "Error loading available payment methods",
      errorOpeningModal: "Error opening modal",
      errorSaving: "Error saving payment method",
      errorTogglingStatus: "Error toggling payment method status",
      errorDeleting: "Error deleting payment method",
      paymentMethodAdded: "Payment method added successfully",
      priorityUpdated: "Priority updated successfully",
      statusToggled: "Payment method status toggled successfully",
      paymentMethodRemoved: "Payment method removed successfully",
    },

    advertiserPaymentMethods: {
      title: "Advertiser Payment Methods",
      addPaymentMethod: "Add Payment Method",
      editPaymentMethod: "Edit Payment Method",
      selectAdvertiser: "Select Advertiser",
      selectPaymentMethod: "Select Payment Method",
      priority: "Priority",
      priorityMin: "Priority must be greater than or equal to 0",
      limit: "Limit",
      limitHint: "Usage limit for this payment method (optional)",
      advertiser: "Advertiser",
      paymentMethod: "Payment Method",
      advertiserRequired: "You must select an advertiser",
      paymentMethodRequired: "You must select a payment method",
      deleteConfirmation: 'Are you sure you want to delete the payment method "{name}" from advertiser "{advertiser}"?',
      errorLoading: "Error loading advertiser payment methods",
      errorLoadingAdvertisers: "Error loading available advertisers",
      errorLoadingAvailable: "Error loading available payment methods",
      errorOpeningModal: "Error opening modal",
      errorSaving: "Error saving payment method",
      errorTogglingStatus: "Error toggling payment method status",
      errorDeleting: "Error deleting payment method",
      paymentMethodAdded: "Payment method added successfully",
      paymentMethodUpdated: "Payment method updated successfully",
      statusToggled: "Payment method status toggled successfully",
      paymentMethodRemoved: "Payment method removed successfully",
    },

    // Tools
    tools: {
      title: "Tools",
      subtitle: "Tools to execute lambdas and query the status of services.",
      noToolsAvailable: "No tools available",
      noToolsDescription: "Tools will appear here when they are available",
      lastExecution: "Last execution",
      execute: "Execute",
      openTool: "Open Tool",
      reprocess: "Reprocess",
      executionCompleted: "Execution completed successfully",
      error: "Error",
      result: "Result",
      close: "Close",
      migration: "Migration",
      processes: "Processes",
      campaignMigration: "Campaign Migration",
      campaignMigrationDescription: "Move campaigns between different accounts",
      campaignMigrationSubtitle: "Move campaigns between accounts safely",
      movistarOcsJob: "Movistar OCS Job",
      movistarOcsJobDescription: "Reprocess pending Movistar OCS jobs",
      movistarOcsBlockNotifications: "Block notifications",
      runFullSegmentation: "Run-Full Segmentation",
      runFullSegmentationDescription: "Runs the full Inngest segmentation process with custom parameters",
      runFullSegmentationDialogSubtitle: "Runs the full Inngest segmentation process",
      runFullSegmentationPrepaid: "Entel Peru Prepaid Segmentation",
      runFullSegmentationPrepaidDescription: "Runs the full prepaid segmentation (account 169) with S3 files",
      runFullSegmentationPrepaidDialogSubtitle: "Triggers prepaid segmentation in Inngest for account 169",
      runFullSegmentationPostpaid: "Entel Peru Postpaid Segmentation",
      runFullSegmentationPostpaidDescription:
        "Runs the full postpaid segmentation (account 168) with CSV audience upload",
      runFullSegmentationPostpaidDialogSubtitle: "Uploads audience to S3 and triggers postpaid segmentation in Inngest",
      cellcPaidSegmentation: "Cell C PAID Segmentation",
      cellcPaidSegmentationDescription:
        "Simulates and confirms Cell C's PAID segmentation (account 136) via Inngest",
      cellcPaidSegmentationDialogSubtitle: "Run a simulation or confirm an already-calculated run to create campaigns",
      createCampaignsFromFilesCardName: "Create campaigns from files",
      createCampaignsFromFilesCardDescription:
        "Calls Inngest api2.create-campaigns-from-files using Redis generated-list data",
      createCampaignsFromFilesDialogTitle: "Create campaigns from files",
      createCampaignsFromFilesDialogSubtitle:
        "Create campaigns from files using the segmentation process (Inngest api2.create-campaigns-from-files)",
      status: {
        online: "Online",
        offline: "Offline",
        maintenance: "Maintenance",
        unknown: "Unknown",
      },
      // Campaign Migration Tool
      campaignMigrationTool: {
        sourceAccount: "Source Account",
        sourceAccountSubtitle: "Select source",
        campaign: "Campaign",
        campaignSubtitle: "Choose campaign",
        targetAccount: "Target Account",
        targetAccountSubtitle: "Select destination",
        template: "Template",
        templateSubtitle: "Link template",
        confirmation: "Confirmation",
        confirmationSubtitle: "Review and execute",
        selectSourceAccount: "Select source account",
        selectCampaign: "Select campaign",
        selectTargetAccount: "Select target account",
        selectTemplate: "Select template",
        previous: "Previous",
        next: "Next",
        executeMigration: "Execute Migration",
        migrationSummary: "Migration summary",
        campaignLabel: "Campaign",
        sourceAccountLabel: "Source account",
        targetAccountLabel: "Target account",
        templateLabel: "Template",
        warning: "Warning",
        warningMessage:
          "This operation will move the selected campaign to the target account and link it to the specified template. This action cannot be undone.",
        migrationResult: "Migration Result",
        migrationSuccessful: "Migration successful",
        migrationError: "Migration error",
        migrationStarted: "Migration has been started successfully. The operation is running in the background.",
        unknownError: "Unknown migration error",
        connectionError: "Connection error",
      },
      createCampaignsFromFiles: {
        stepAccount: "Account",
        stepAccountSubtitle: "Select account",
        stepDay: "Day",
        stepDaySubtitle: "Select available day",
        stepConfirm: "Confirmation",
        stepConfirmSubtitle: "Review and execute",
        accountTitle: "Account",
        accountSubtitle: "Select the account to list days with generated-list in Redis",
        selectAccount: "Select account",
        searchAccountsHint: "Type to search accounts",
        dayTitle: "Available day",
        daySubtitle: "Select the generated-list day you want to use",
        noDays: "No days with generated-list for this account in Redis.",
        confirmTitle: "Confirmation",
        confirmSubtitle: "Review the data before calling Inngest",
        summaryTitle: "Generated-list data (Redis)",
        account: "Account",
        month: "Month",
        bucketS3: "S3 Bucket",
        keyZip: "ZIP Key",
        servicesCsvFiles: "Services and CSV files",
        servicesCount: "{count} service(s)",
        csvFilesCount: "{count} CSV file(s)",
        warningInngest: "The event api2.create-campaigns-from-files will be sent to Inngest with this data.",
        loadHashError: "Could not load hash. Go back to the previous step.",
        previous: "Previous",
        next: "Next",
        executeInngest: "Execute Inngest",
        result: "Result",
        successTitle: "Execution successful",
        successMessage: "Event sent to Inngest successfully",
        errorTitle: "Error",
        close: "Close",
      },
    },

    // Entel Stats
    entelStats: {
      title: "Entel Statistics",
      subtitle: "Load and edit monthly service statistics for Entel.",
      back: "Back to Tools",
      selectMonth: "Month",
      selectYear: "Year",
      services: "services",
      prepaid: "Entel Prepaid",
      postpaid: "Entel Postpaid",
      save: "Save",
      close: "Close",
      noServices: "No services available for this account",
      savedSuccess: "{saved} row(s) saved, {skipped} skipped",
      errorLoading: "Error loading statistics",
      errorSaving: "Error saving statistics",
      toolCardName: "Entel Statistics",
      toolCardDescription: "Load and edit monthly service statistics for Entel Peru.",
      toolCardCategory: "Statistics",
      toolCardAction: "Go to tool",
      cols: {
        service: "Service",
        advertiser: "Advertiser",
        activations: "Activations",
        finalsActivations: "Final Act.",
        validAcceptances: "Valid Acceptances",
        pending: "Pending",
        delivered: "Delivered",
        remainder: "Remainder",
      },
    },

    // SIM Cards Information
    simCards: {
      title: "SIM Cards Information",
      subtitle: "Query and manage SIM card information",
      listTitle: "SIM Cards List",
      createNew: "New SIM Card",
      noResults: "No SIM cards found with the applied filters",
      details: "SIM Card Details",
      backToList: "Back to SIM Cards",
      filters: "Filters",
      clearFilters: "Clear Filters",
      country: "Country",
      operator: "Operator/Network",
      basicInfo: "Basic Information",
      networkInfo: "Network Information",
      supportAndErrors: "Support and Errors",
      iccid: "ICCID",
      imsi: "IMSI",
      manufacturer: "Manufacturer",
      freespace: "Free Space",
      atrData: "ATR Data",
      dateOfTest: "Test Date",
      tarAvailable: "TAR Available",
      mcc: "MCC",
      mnc: "MNC",
      iso: "ISO",
      countryCode: "Country Code",
      satSupport: "SAT Support",
      seSupport: "SE Support",
      wibDirectory: "WIB Directory",
      securityScreen: "Security Screen",
      satErrors: "SAT Errors",
      seErrors: "SE Errors",
      yes: "Yes",
      no: "No",
    },

    auditLog: {
      title: "Audit Log",
      subtitle: "Record of user actions against the API",
      noData: "No audit records for the applied filters",
      fields: {
        created_at: "Date",
        actor_email: "User",
        user_id: "User ID",
        category: "Category",
        action: "Action",
        resource: "Resource",
        resource_id: "Resource ID",
        method: "Method",
        path: "Path",
        result: "Result",
        severity: "Severity",
        source: "Source",
        ip_address: "IP",
        user_agent: "User Agent",
        request_id: "Request ID",
        changes: "Changes",
      },
      categories: { action: "Action", security: "Security" },
      results: { success: "Success", failure: "Failure" },
      severities: { low: "Low", medium: "Medium", high: "High", critical: "Critical" },
      source: { hot: "Recent", cold: "Historical" },
      filters: {
        dateFrom: "From",
        dateTo: "To",
        userId: "User ID",
        actorEmail: "User (email)",
        action: "Action",
        resource: "Resource",
        category: "Category",
        result: "Result",
        sortOrder: "Order",
        sortDesc: "Newest first",
        sortAsc: "Oldest first",
        accounts: "Accounts",
        account: "Account",
        accountsPlaceholder: "All accounts",
      },
      detail: {
        title: "Event Detail",
        event: "Event",
        actor: "Actor",
        changes: "Changes",
      },
      diff: {
        field: "Field",
        before: "Before",
        after: "After",
        noChanges: "No changes recorded",
      },
      export: {
        label: "Export CSV",
        tooltip: "Download filtered audit log as CSV",
        error: "Export failed. Please try again.",
      },
    },
    creativityFieldLocks: {
      title: 'Locked texts',
      description: 'Creativity fields whose text is imposed by the operator: the platform renders them disabled and pre-filled with this text. Editing it here needs no deploy.',
      filterAccount: 'Filter by account',
      add: 'New text',
      account: 'Account',
      scenarioType: 'Scenario type',
      field: 'Field',
      fieldHint: 'Only creativity fields of the selected scenario type are listed.',
      pickScenarioFirst: 'Pick a scenario type first.',
      text: 'Locked text',
      active: 'Active',
      actions: 'Actions',
      yes: 'Yes',
      no: 'No',
      empty: 'No locked texts configured.',
      rawLength: '{n} unresolved characters',
      addTitle: 'New locked text',
      editTitle: 'Edit locked text',
      scopeImmutable: 'Account, scenario type and field are not editable. To move it, delete this row and create a new one.',
      tokensHelp: 'The platform replaces these tokens with the template data when the creativity is created. Any other {TOKEN} is rejected because it would be sent to the device as-is.',
      satLengthWarning: 'The raw text is {n} characters and an S@T opt-in allows {max}. It may fit once the tokens are resolved — check it in the platform.',
      cancel: 'Cancel',
      save: 'Save',
      saved: 'Locked text saved.',
      saveFailed: 'Could not save the locked text.',
      propagationWarning: 'Saving rewrites the creativities that already exist in this scope, resolving the tokens with each template\'s name and price. It runs in the background and is all-or-nothing: if one fails, none are modified.',
      savedAndEnqueued: 'Saved. Propagation to the existing templates has been queued.',
      savedEnqueueFailed: 'The text was saved, but the propagation could not be queued: {error}. Use the re-propagate button.',
      propagate: 'Re-propagate to the existing templates',
      propagateInactive: 'An inactive text is not propagated',
      propagationEnqueued: 'Propagation queued.',
      propagationFailed: 'Could not queue the propagation.',
      loadFailed: 'Could not load the locked texts.',
      fieldsFailed: 'Could not load the scenario type fields.',
      remove: 'Delete',
      removeTitle: 'Delete locked text',
      removeConfirm: 'Delete the locked text for {scope}?',
      removeWarning: 'The field becomes editable again in the platform and will be empty on new creativities.',
      removed: 'Locked text deleted.',
      removeFailed: 'Could not delete the locked text.',
      errTextRequired: 'Text is required.',
      errAccountRequired: 'Pick an account.',
      errScenarioTypeRequired: 'Pick a scenario type.',
      errFieldRequired: 'Pick a field.',
    },
    myAccount: {
      menuTitle: 'My account',
      viewDetail: 'View detail',
      title: 'My account',
      description: 'Last access and login attempt history (audit control 042-09).',
      lastAccessTitle: 'Last access',
      lastAccessUnknown: 'No previous access recorded.',
      fromIp: 'from {ip}',
      sourceProduct: 'Dynamo',
      sourceBackoffice: 'Backoffice',
      historyTitle: 'Recent login attempts',
      empty: 'No login attempts recorded.',
      loadFailed: 'Could not load account activity.',
      columnDate: 'Date',
      columnResult: 'Result',
      columnReason: 'Reason',
      columnDevice: 'Device',
      deviceUnknown: 'Unknown',
      showingRange: 'Showing {from}-{to} of {total}',
      columnIp: 'IP',
      resultSuccess: 'Successful',
      resultFailure: 'Failed',
      reasonLoginSuccess: 'Successful login',
      reasonLoginInvalidPassword: 'Incorrect password',
      reasonLoginInvalid2faCode: 'Invalid verification code',
      reasonLoginAccountLocked: 'Account locked',
      reasonLoginAccountLockedOut: 'Account locked (too many attempts)',
      reasonLoginInactiveUser: 'Inactive account',
      reasonLoginUserNotFound: 'User not found',
      reasonLogin2faSetupRequired: 'Two-factor setup required',
      reasonLogin2faExempt: 'Signed in without 2FA (exempt user)',
      reason2faEnrolledAtLogin: 'Two-factor authentication set up at sign-in',
      noticeSingular: 'We detected 1 failed login attempt since your last access, on {date}.',
      noticePlural: 'We detected {n} failed login attempts since your last access, on {date}.',
    },
    // DD-1771 — no había bloque twoFactor en inglés (fallback del i18n): sin él, la pantalla
    // bloqueante del login mostraba las claves crudas.
    twoFactor: {
      title: 'Two-factor authentication',
      subtitle: 'Add an extra layer of security to your account.',
      disabledTitle: '2FA is currently disabled',
      disabledDescription: 'Enable two-factor authentication to protect your account.',
      enable: 'Enable 2FA',
      enabledTitle: '2FA is enabled',
      disable: 'Disable 2FA',
      chooseMethod: 'Choose how you want to receive the verification code.',
      methodEmail: 'Email',
      methodEmailDescription: 'Receive the code by email.',
      methodTotp: 'Authenticator app',
      methodTotpDescription: 'Use Google Authenticator, Authy or similar.',
      cancel: 'Cancel',
      scanQr: 'Scan this QR code with your authenticator app.',
      manualKey: 'Or enter this key manually',
      copy: 'Copy',
      copied: 'Key copied',
      enterCode: 'Enter the 6-digit code from your app',
      verifyAndEnable: 'Verify and enable',
      back: 'Back',
      disableWarning: 'This reduces your account security. You can enable it again at any time.',
      enterCurrentCode: 'Enter your current 6-digit code to confirm',
      confirmDisable: 'Disable',
      errorGeneric: 'Something went wrong. Please try again.',
      errorInvalidCode: 'Invalid verification code.',
      requiredHint: 'Your account requires two-factor authentication: it cannot be disabled.',
      forcedTitle: 'Set up two-factor authentication',
      forcedSubtitle: 'Your account requires 2FA. Set it up to sign in.',
      emailCodeSent: 'We sent you a 6-digit code by email.',
      enterEmailCode: 'Enter the code you received by email',
      verifyAndContinue: 'Verify and continue',
      changeMethod: 'Change method',
      backToLogin: 'Back to login',
    },
    accountTwoFactor: {
      label: 'Require 2FA for this account\'s users',
      chipRequired: '2FA required',
      chipOptional: '2FA optional',
      enableTitle: 'Require 2FA',
      enableText: '{pending} of {total} users do not have 2FA yet: they will be asked to set it up on their next sign-in.',
      disableTitle: 'Stop requiring 2FA',
      disableText: '2FA becomes optional for this account\'s users. Users who already set it up keep it.',
      confirm: 'Confirm',
      cancel: 'Cancel',
      saveError: 'Could not change the account\'s 2FA requirement.',
      loadError: 'Could not load the account\'s 2FA status.',
      title: 'Two-factor authentication (2FA)',
      descriptionOn: 'Every user assigned to this account must use 2FA. Users who have not set it up will do so on their next sign-in.',
      descriptionOff: 'Turn it on to require 2FA for every user assigned to this account, new and existing.',
      usersSummary: '{total} users in the account · {pending} without 2FA',
      allConfigured: 'Every user in the account has 2FA',
      allConfiguredNonExempt: 'Every non-exempt user has 2FA',
      exemptSummary: '{count} exempt | {count} exempt',
      enableAction: 'Require 2FA',
      disableAction: 'Stop requiring',
      superadminOnly: 'Only a superadmin can change it.',
    },
    userTwoFactorReset: {
      button: 'Reset 2FA',
      title: 'Confirm 2FA reset',
      question: 'Are you sure you want to reset two-factor authentication (2FA) for user {username}?',
      description: 'The current 2FA setup (authenticator app or email) will be removed. If any of their accounts requires 2FA, they will have to set it up again on their next sign-in.',
      cancel: 'Cancel',
      confirm: 'Reset 2FA',
    },
    channelPrices: {
      title: 'Channel prices',
      description: 'Set the unit price per billable channel for each account. Prices are versioned by date — changing a price never overwrites history.',
      account: 'Account',
      selectAccount: 'Select an account to view and configure prices.',
      channel: 'Channel',
      currentPrice: 'Current price',
      currency: 'Currency',
      validFrom: 'Valid from',
      actions: 'Actions',
      notSet: '— not set —',
      changePrice: 'Change price',
      history: 'History',
      hideHistory: 'Hide history',
      noHistory: 'No previous prices for this channel.',
      price: 'Price',
      validTo: 'Valid to',
      current: '— current —',
      changePriceTitle: 'Change price — {channel}',
      changePriceHelper: 'Creates a new price row and closes the current one on the previous day. The current price stays available for reporting on past periods.',
      newPrice: 'New price',
      cancel: 'Cancel',
      save: 'Save',
      priceUpdated: 'Price updated',
      priceSaveFailed: 'Failed to save price',
      selectAccountFirst: 'Select an account first',
      errPriceNonNegative: 'Price must be a non-negative number',
      errCurrency: 'Currency must be a 3-letter code (e.g. USD)',
      errValidFrom: 'Valid from must be a date (YYYY-MM-DD)',
      mode: 'Mode',
      modeFixed: 'Fixed',
      modeVariable: 'Variable',
      modeTiered: 'Tiered',
      helpFixed: 'One flat price per send. Total = sends × price.',
      helpVariable: "The total monthly volume lands in a tier and every send is billed at that tier's price.",
      helpTiered: 'Each tier is billed at its own price, cumulative across the monthly volume.',
      tiersSummary: '{n} tiers',
      tiersDetail: 'Configured tiers:',
      tierFrom: 'From (units)',
      tierPrice: 'Price',
      addTier: 'Add tier',
      errAtLeastOneTier: 'Configure at least one tier',
      errFirstTierZero: 'The first tier must start at 0',
      errTierFromInteger: 'Tier start must be a non-negative integer',
      errTierPriceNonNegative: 'Tier price must be non-negative',
      errTierIncreasing: 'Tiers must be strictly increasing by units'
    }
  },

  pt: {
    common: {
      // Navigation
      dashboard: "Dashboard",
      campaigns: "Campanhas",
      templates: "Templates",
      categories: "Categorias",
      advertisers: "Anunciantes",
      accounts: "Contas",
      account: "Conta",
      users: "Usuários",
      profiles: "Perfis",
      operators: "Operadores",
      countries: "Países",
      scenarioTypes: "Tipos de Cenário",
      auditLog: "Auditoria",

      // Actions
      create: "Criar",
      edit: "Editar",
      update: "Atualizar",
      delete: "Excluir",
      view: "Ver",
      save: "Salvar",
      cancel: "Cancelar",
      close: "Fechar",
      back: "Voltar",
      search: "Buscar",
      filter: "Filtrar",
      clearFilters: "Limpar Filtros",
      confirmDelete: "Confirmar Exclusão",
      actions: "Ações",
      deleteSelected: "Excluir Selecionados",
      clearSelection: "Limpar Seleção",
      clearAll: "Limpar Tudo",

      // Status
      status: {
        active: "Ativo",
        inactive: "Inativo",
        pending: "Pendente",
        suspended: "Suspenso",
        enabled: "Habilitado",
        disabled: "Desabilitado",
      },

      // Status object for nested access
      statusTypes: {
        active: "Ativo",
        inactive: "Inativo",
        pending: "Pendente",
        suspended: "Suspenso",
        enabled: "Habilitado",
        disabled: "Desabilitado",
      },

      // Dates
      created: "Criado",
      modified: "Modificado",

      // Validation
      required: "Este campo é obrigatório",
      invalidEmail: "Email inválido",
      invalidPhone: "Número de telefone inválido",
      invalidUrl: "URL inválida",
      positiveValue: "O valor deve ser positivo",
      selectUser: "Deve selecionar um usuário",
      selectVariable: "Deve selecionar uma variável",
      msisdnFormat: "MSISDN deve conter entre 7 e 15 dígitos",
      positive: "O valor deve ser positivo",
      positiveNumber: "Deve ser um número positivo",
      validNumber: "Deve ser um número válido",

      // Messages
      loading: "Carregando...",
      noData: "Nenhum dado disponível",
      none: "Nenhum",
      error: "Erro",
      success: "Sucesso",
      accessDenied: "Acesso Negado",
      yes: "Sim",
      no: "Não",

      // Status (direct access)
      active: "Ativo",
      inactive: "Inativo",

      // Error messages
      errorMessages: {
        saving: "Erro ao salvar",
        loading: "Erro ao carregar",
        deleting: "Erro ao excluir",
        updating: "Erro ao atualizar",
        creating: "Erro ao criar",
      },

      // Validation nested object
      validation: {
        required: "Este campo é obrigatório",
        email: "Deve ser um email válido",
        minLength: "Deve ter pelo menos {min} caracteres",
        maxLength: "Não pode ter mais de {max} caracteres",
        numeric: "Deve ser um número válido",
        url: "Deve ser uma URL válida",
        msisdnFormat: "MSISDN deve conter entre 7 e 15 dígitos",
      },
      backendAccessRequired: "É necessário acesso ao backend para usar esta aplicação",
      retry: "Tentar novamente",
      currentLanguage: "Idioma Atual",
      default: "Padrão",
      native: "Nativo",
      browserLanguage: "Idioma do Navegador",
      browserDetected: "Detectado pelo Navegador",

      // Pagination
      itemsPerPage: "Itens por página",
      pageText: "Página",
      page: "Página",
      of: "de",
      nextPage: "Próxima página",
      prevPage: "Página anterior",
      firstPage: "Primeira página",
      lastPage: "Última página",
      id: "ID",
      locale: "pt-BR",
      all: "Todos",
      pageOf: "{page} de {total}",
      pageRange: "{start}-{end} de {total}",
      notAvailable: "N/A",
      showing: "Mostrando",
      items: "itens",
    },

    // Users
    users: {
      title: "Usuários",
      subtitle: "Gerencia os usuários do sistema",
      createTitle: "Criar Usuário",
      createSubtitle: "Criar um novo usuário",
      createUser: "Criar Usuário",
      editTitle: "Editar Usuário",
      editSubtitle: "Modificar dados do usuário",
      editUser: "Editar Usuário",
      username: "Usuário",
      email: "Email",
      firstname: "Nome",
      lastname: "Sobrenome",
      fullName: "Nome Completo",
      role: "Função",
      admin: "Administrador",
      manager: "Gerente",
      operator: "Operador",
      user: "Usuário",
      unknown: "Desconhecido",
      enable: "Habilitar",
      disable: "Desabilitar",
      password: "Senha",
      confirmPassword: "Confirmar Senha",
      position: "Cargo",
      defaultLanguage: "Idioma Padrão",
      selectedAccount: "Conta Selecionada",
      landingPage: "Página Inicial",
      backendAccess: "Acesso ao Backend",
      basicInfo: "Informações Básicas",
      passwordInfo: "Informações de Senha",
      roleAndStatus: "Função e Status",
      additionalInfo: "Informações Adicionais",
      associations: "Associações",
      userProfiles: "Perfis de Usuário",
      account: "Conta",
      profile: "Perfil",
      invalidUsername: "O usuário deve ter entre 3 e 20 caracteres alfanuméricos",
      passwordMinLength: "A senha deve ter pelo menos 6 caracteres",
      passwordMismatch: "As senhas não coincidem",
      enableSuccess: "Usuário habilitado com sucesso",
      disableSuccess: "Usuário desabilitado com sucesso",
      createSuccess: "Usuário criado com sucesso",
      updateSuccess: "Usuário atualizado com sucesso",
      saveSuccess: "Usuário salvo com sucesso",
      deleteSuccess: "Usuário excluído com sucesso",
      deleteConfirm: 'Tem certeza de que deseja excluir o usuário "{name}"?',
      changePassword: "Alterar Senha",
      passwordUpdateSuccess: "Senha atualizada e enviada por email",
      passwordUpdateSuccessNoEmail: "Senha atualizada. Não foi possível enviar o email de aviso",
      temporaryPasswordNotice: "O usuário deverá definir uma nova senha ao entrar. Esta senha temporária expira em 30 dias.",
      temporaryPasswordEmailNotice: "Será enviada por email para {email}.",
      createSuccessEmailSent: "Usuário criado. O e-mail de boas-vindas foi enviado para {email}",
      createSuccessNoEmail: "Usuário criado. Não foi possível enviar o e-mail de boas-vindas: reenvie-o em Segurança",
      welcomeEmailCreateNotice: "Ao criar o usuário, ele receberá um e-mail com seu usuário, esta senha temporária e o link de acesso. Deverá alterá-la ao entrar; expira em 30 dias.",
      welcomeEmailTitle: "E-mail de boas-vindas",
      welcomeEmailDescription: "Se o usuário não recebeu o e-mail com seus dados de acesso, é possível reenviá-lo. Uma nova senha temporária é gerada e a anterior deixa de funcionar.",
      welcomeEmailResend: "Reenviar e-mail de boas-vindas",
      welcomeEmailConfirmTitle: "Reenviar e-mail de boas-vindas",
      welcomeEmailConfirmText: "Uma nova senha temporária será gerada e enviada para {email}. A senha anterior deixará de funcionar.",
      welcomeEmailResent: "E-mail de boas-vindas reenviado para {email}",
      welcomeEmailResentNoEmail: "Uma nova senha foi gerada, mas não foi possível enviar o e-mail. Tente novamente em alguns minutos.",
      welcomeEmailNoEmail: "O usuário não tem e-mail cadastrado",
      welcomeEmailAlreadyLoggedInTitle: "Não é possível reenviar o e-mail de boas-vindas",
      welcomeEmailAlreadyLoggedInText: "O usuário já entrou na plataforma, por isso não é possível reenviar o e-mail de boas-vindas. Recomendamos redefinir a senha: ele receberá um e-mail com uma senha temporária.",
      welcomeEmailResetPassword: "Redefinir senha",
      welcomeEmailError: "Não foi possível reenviar o e-mail de boas-vindas",

      // User fields
      fields: {
        username: "Usuário",
        email: "Email",
        firstname: "Nome",
        lastname: "Sobrenome",
        status: "Status",
        advertiser: "Anunciante",
        position: "Cargo",
        defaultLanguage: "Idioma Padrão",
        backendAccess: "Acesso ao Backend",
        subdomainAccess: "Acesso a Subdomínio",
        landingPage: "Página Inicial",
        selectedAccount: "Conta Selecionada",
        password: "Senha",
        newPassword: "Nova Senha",
        confirmPassword: "Confirmar Senha",
      },
    },

    // MSISDN Validators
    msisdnValidators: {
      title: "Validadores MSISDN",
      description: "Gerencia as regras de validação de números de telefone por país",
      newValidator: "Novo Validador",
      searchByCountryCode: "Buscar por código do país",
      filterByAction: "Filtrar por ação",
      addCountryCode: "Adicionar código",
      trimCountryCode: "Recortar código",
      addCode: "Adicionar código",
      trimCode: "Recortar código",
      countryCode: "Código do País",
      showingResults: "Mostrando {filtered} de {total} resultados",
      lengthRange: "Faixa de Comprimento",
      action: "Ação",
      autocomplete: "Autocompletar",
      createTitle: "Criar Validador",
      editTitle: "Editar Validador",
      minLength: "Comprimento Mínimo",
      maxLength: "Comprimento Máximo",
      deleteConfirm: 'Tem certeza de que deseja excluir o validador para o país "{countryCode}"?',
      createSuccess: "Validador criado com sucesso",
      updateSuccess: "Validador atualizado com sucesso",
      deleteSuccess: "Validador excluído com sucesso",
      createdSuccessfully: "Validador criado com sucesso",
      updatedSuccessfully: "Validador atualizado com sucesso",
      deletedSuccessfully: "Validador excluído com sucesso",
    },

    accountDetail: {
      title: "Configuração da Conta",
      backToAccounts: "Voltar para Contas",
      loading: "Carregando configuração da conta...",
      error: "Erro ao carregar a configuração da conta",
      variables: "Variáveis",
      smppConnections: "Conexões SMPP",
      scenarioTypes: "Tipos de Cenário",
      userProfiles: "Usuários e Perfis",
      commercialAdmins: "Administradores Comerciais",
      operationalAdmins: "Administradores Operacionais",
      paymentMethods: "Métodos de Pagamento",
      advertiserPaymentMethods: "Métodos de Pagamento de Anunciantes",
      campaignCategories: "Categorias da conta",
      blacklistSecondAction: "Blacklist Second Action",
    },

    smppConnections: {
      title: "Conexões SMPP",
      description: "Gerencia as conexões SMPP da conta",
      addConnection: "Adicionar Conexão",
      createConnection: "Criar Conexão",
      editConnection: "Editar Conexão",
      noConnections: "Não há conexões disponíveis",
      name: "Nome",
      url: "URL",
      urlSms: "URL SMS",
      urlFlashsms: "URL Flash SMS",
      urlStatus: "URL Status",
      throughput: "Throughput",
      throughputHint: "Mensagens por segundo",
      messagesPerSecond: "msg/s",
      status: "Status",
      maxQueue: "Fila Máxima",
      usleepPerMsgSent: "Usleep por Mensagem",
      checkEachNSecs: "Verificar a cada N segundos",
      checkStatus: "Verificar Estado",
      statusResults: "Resultados de Estado",
      testsTitle: "Testes de conexão SMPP",
      runTest: "Executar Teste",
      testType: "Tipo de teste",
      msisdn: "MSISDN",
      message: "Mensagem",
      senderId: "Sender ID",
      messageCount: "Quantidade de mensagens",
      lastTestResult: "Último Resultado",
      testHistory: "Histórico",
      testStatusSuccess: "Sucesso",
      testStatusFailed: "Falhou",
      mockNotice: "Este é um teste mock do cliente. A integração com backend está pendente.",
      noTests: "Nenhum teste executado ainda",
      testDialog: {
        tabs: {
          fullExecution: "Execução completa de testes",
          unitTests: "Testes unitários",
        },
        fullExecution: {
          title: "Testes de validação de conexão:",
          presetsTitle: "Testes predefinidos",
          presets: {
            sms: {
              title: "Envio de um SMS",
              subtitle: "Envia um SMS de teste com o texto 'Test SMS'",
            },
            satPingPorOn: {
              title: "Envio de um SAT PING com PoR: ON",
              subtitle: "SAT mode PING, PoR ON",
            },
            satPingPorOff: {
              title: "Envio de um SAT PING com PoR: OFF",
              subtitle: "SAT mode PING, PoR OFF",
            },
            satMsgCapture: {
              title: "Envio de um SAT MSG (captura)",
              subtitle:
                'SAT mode MSG. Mensagem: "This message is a test. Please capture the screen and share the results"',
            },
          },
        },
        unitTests: {
          sendType: {
            sms: "SMS",
            flashSms: "FlashSMS",
            sat: "SAT",
          },
          dlrLabel: "DLR",
          on: "On",
          off: "Off",
          satModeLabel: "SAT mode",
          satModePing: "PING",
          satModeMsg: "MSG",
          porLabel: "PoR",
          true: "True",
          false: "False",
          satMsgLabel: "SAT MSG",
        },
        smsHint: {
          invalidCharsRemoved: "caracteres inválidos removidos",
          truncatedToLimit: "recortado ao máximo permitido",
        },
      },
      createSuccess: "Conexão criada com sucesso",
      updateSuccess: "Conexão atualizada com sucesso",
      deleteSuccess: "Conexão excluída com sucesso",
      deleteConfirm: 'Tem certeza de que deseja excluir a conexão "{name}"?',
      errorLoading: "Erro ao carregar as conexões",
      errorCheckingStatus: "Erro ao verificar o status da conexão",
    },

    accountCampaignCategories: {
      title: "Categorias da conta",
      description: "Gerencia as categorias da conta",
      categoryName: "Nome da Categoria",
      status: "Status",
      toggleSuccess: "Categoria atualizada com sucesso",
      noCategories: "Não há categorias disponíveis",
      searchPlaceholder: "Buscar categoria...",
    },

    // Tools
    tools: {
      title: "Ferramentas",
      subtitle: "Ferramentas para executar lambdas e consultar o status dos serviços",
      noToolsAvailable: "Nenhuma ferramenta disponível",
      noToolsDescription: "As ferramentas aparecerão aqui quando estiverem disponíveis",
      lastExecution: "Última execução",
      execute: "Executar",
      openTool: "Abrir Ferramenta",
      reprocess: "Reprocessar",
      executionCompleted: "Execução concluída com sucesso",
      error: "Erro",
      result: "Resultado",
      close: "Fechar",
      migration: "Migração",
      processes: "Processos",
      campaignMigration: "Migração de Campanhas",
      campaignMigrationDescription: "Move campanhas entre diferentes contas",
      campaignMigrationSubtitle: "Mover campanhas entre contas com segurança",
      movistarOcsJob: "Movistar OCS Job",
      movistarOcsJobDescription: "Reprocessa os jobs pendentes do Movistar OCS",
      movistarOcsBlockNotifications: "Bloquear notificações",
      runFullSegmentation: "Run-Full Segmentação",
      runFullSegmentationDescription: "Executa o run-full de segmentação do Inngest com parâmetros personalizados",
      runFullSegmentationDialogSubtitle: "Executa o run-full de segmentação do Inngest",
      runFullSegmentationPrepaid: "Segmentação Entel Peru Pré-pago",
      runFullSegmentationPrepaidDescription: "Executa o run-full de segmentação pré-pago (conta 169) com arquivos S3",
      runFullSegmentationPrepaidDialogSubtitle: "Dispara a segmentação pré-pago no Inngest para a conta 169",
      runFullSegmentationPostpaid: "Segmentação Entel Peru Pós-pago",
      runFullSegmentationPostpaidDescription:
        "Executa o run-full de segmentação pós-pago (conta 168) com upload de audiência CSV",
      runFullSegmentationPostpaidDialogSubtitle:
        "Faz upload da audiência para S3 e dispara a segmentação pós-pago no Inngest",
      cellcPaidSegmentation: "Segmentação Cell C PAID",
      cellcPaidSegmentationDescription:
        "Simula e confirma a segmentação PAID da Cell C (conta 136) via Inngest",
      cellcPaidSegmentationDialogSubtitle: "Executa uma simulação ou confirma uma corrida já calculada para criar as campanhas",
      createCampaignsFromFilesCardName: "Criar campanhas a partir de arquivos",
      createCampaignsFromFilesCardDescription:
        "Chama o Inngest api2.create-campaigns-from-files usando dados do Redis (generated-list)",
      createCampaignsFromFilesDialogTitle: "Criar campanhas a partir de arquivos",
      createCampaignsFromFilesDialogSubtitle:
        "Cria as campanhas a partir de arquivos usando o processo de segmentação (Inngest api2.create-campaigns-from-files)",
      status: {
        online: "Online",
        offline: "Offline",
        maintenance: "Manutenção",
        unknown: "Desconhecido",
      },
      // Campaign Migration Tool
      campaignMigrationTool: {
        sourceAccount: "Conta Origem",
        sourceAccountSubtitle: "Selecionar origem",
        campaign: "Campanha",
        campaignSubtitle: "Escolher campanha",
        targetAccount: "Conta Destino",
        targetAccountSubtitle: "Selecionar destino",
        template: "Template",
        templateSubtitle: "Vincular template",
        confirmation: "Confirmação",
        confirmationSubtitle: "Revisar e executar",
        selectSourceAccount: "Selecionar conta origem",
        selectCampaign: "Selecionar campanha",
        selectTargetAccount: "Selecionar conta destino",
        selectTemplate: "Selecionar template",
        previous: "Anterior",
        next: "Próximo",
        executeMigration: "Executar Migração",
        migrationSummary: "Resumo da migração",
        warning: "Aviso",
        warningMessage:
          "Esta operação moverá a campanha selecionada para a conta destino e a vinculará ao template especificado. Esta ação não pode ser desfeita.",
        migrationResult: "Resultado da Migração",
        migrationSuccessful: "Migração bem-sucedida",
        migrationError: "Erro na migração",
        migrationStarted: "A migração foi iniciada com sucesso. A operação está sendo executada em segundo plano.",
        unknownError: "Erro desconhecido na migração",
        connectionError: "Erro de conexão",
      },
      createCampaignsFromFiles: {
        stepAccount: "Conta",
        stepAccountSubtitle: "Selecionar conta",
        stepDay: "Dia",
        stepDaySubtitle: "Selecionar dia disponível",
        stepConfirm: "Confirmação",
        stepConfirmSubtitle: "Revisar e executar",
        accountTitle: "Conta",
        accountSubtitle: "Selecione a conta para listar os dias com generated-list no Redis",
        selectAccount: "Selecionar conta",
        searchAccountsHint: "Digite para buscar contas",
        dayTitle: "Dia disponível",
        daySubtitle: "Selecione o dia do generated-list que deseja usar",
        noDays: "Não há dias com generated-list para esta conta no Redis.",
        confirmTitle: "Confirmação",
        confirmSubtitle: "Revise os dados antes de chamar o Inngest",
        summaryTitle: "Dados do generated-list (Redis)",
        account: "Conta",
        month: "Mês",
        bucketS3: "Bucket S3",
        keyZip: "Key ZIP",
        servicesCsvFiles: "Serviços e arquivos CSV",
        servicesCount: "{count} serviço(s)",
        csvFilesCount: "{count} arquivo(s) CSV",
        warningInngest: "O evento api2.create-campaigns-from-files será enviado ao Inngest com estes dados.",
        loadHashError: "Não foi possível carregar o hash. Volte ao passo anterior.",
        previous: "Anterior",
        next: "Próximo",
        executeInngest: "Executar Inngest",
        result: "Resultado",
        successTitle: "Execução bem-sucedida",
        successMessage: "Evento enviado ao Inngest com sucesso",
        errorTitle: "Erro",
        close: "Fechar",
      },
    },

    // Entel Stats
    entelStats: {
      title: "Estatísticas Entel",
      subtitle: "Carregamento e edição de estatísticas mensais de serviços Entel.",
      back: "Voltar para Ferramentas",
      selectMonth: "Mês",
      selectYear: "Ano",
      services: "serviços",
      prepaid: "Entel Pré-pago",
      postpaid: "Entel Pós-pago",
      save: "Salvar",
      close: "Fechar",
      noServices: "Nenhum serviço disponível para esta conta",
      savedSuccess: "{saved} linha(s) salvas, {skipped} ignoradas",
      errorLoading: "Erro ao carregar estatísticas",
      errorSaving: "Erro ao salvar estatísticas",
      toolCardName: "Estatísticas Entel",
      toolCardDescription: "Carregamento e edição de estatísticas mensais de serviços Entel Peru.",
      toolCardCategory: "Estatísticas",
      toolCardAction: "Ir para ferramenta",
      cols: {
        service: "Serviço",
        advertiser: "Anunciante",
        activations: "Ativações",
        finalsActivations: "Ativ. Finais",
        validAcceptances: "Aceitações Válidas",
        pending: "Pendentes",
        delivered: "Entregues",
        remainder: "Restante",
      },
    },

    // SIM Cards Information
    simCards: {
      title: "Informação de SIM Cards",
      subtitle: "Consultar e gerenciar informações de cartões SIM",
      listTitle: "Lista de SIM Cards",
      createNew: "Nova SIM Card",
      noResults: "Nenhuma SIM card encontrada com os filtros aplicados",
      details: "Detalhes da SIM Card",
      backToList: "Voltar para SIM Cards",
      filters: "Filtros",
      clearFilters: "Limpar Filtros",
      country: "País",
      operator: "Operador/Rede",
      basicInfo: "Informação Básica",
      networkInfo: "Informação de Rede",
      supportAndErrors: "Suporte e Erros",
      iccid: "ICCID",
      imsi: "IMSI",
      manufacturer: "Fabricante",
      freespace: "Espaço Livre",
      atrData: "ATR Data",
      dateOfTest: "Data do Teste",
      tarAvailable: "TAR Available",
      mcc: "MCC",
      mnc: "MNC",
      iso: "ISO",
      countryCode: "Código do País",
      satSupport: "SAT Support",
      seSupport: "SE Support",
      wibDirectory: "WIB Directory",
      securityScreen: "Security Screen",
      satErrors: "SAT Errors",
      seErrors: "SE Errors",
      yes: "Sim",
      no: "Não",
    },

    auditLog: {
      title: "Auditoria",
      subtitle: "Registro de ações de usuários contra a API",
      noData: "Nenhum registro de auditoria para os filtros aplicados",
      fields: {
        created_at: "Data",
        actor_email: "Usuário",
        user_id: "ID Usuário",
        category: "Categoria",
        action: "Ação",
        resource: "Recurso",
        resource_id: "ID Recurso",
        method: "Método",
        path: "Rota",
        result: "Resultado",
        severity: "Severidade",
        source: "Origem",
        ip_address: "IP",
        user_agent: "User Agent",
        request_id: "Request ID",
        changes: "Alterações",
      },
      categories: { action: "Ação", security: "Segurança" },
      results: { success: "Sucesso", failure: "Falha" },
      severities: { low: "Baixa", medium: "Média", high: "Alta", critical: "Crítica" },
      source: { hot: "Recente", cold: "Histórico" },
      filters: {
        dateFrom: "De",
        dateTo: "Até",
        userId: "ID Usuário",
        actorEmail: "Usuário (email)",
        action: "Ação",
        resource: "Recurso",
        category: "Categoria",
        result: "Resultado",
        sortOrder: "Ordem",
        sortDesc: "Mais recentes primeiro",
        sortAsc: "Mais antigos primeiro",
        accounts: "Contas",
        account: "Conta",
        accountsPlaceholder: "Todas as contas",
      },
      detail: {
        title: "Detalhe do Evento",
        event: "Evento",
        actor: "Ator",
        changes: "Alterações",
      },
      diff: {
        field: "Campo",
        before: "Antes",
        after: "Depois",
        noChanges: "Sem alterações registradas",
      },
      export: {
        label: "Exportar CSV",
        tooltip: "Baixar auditoria filtrada como CSV",
        error: "Erro ao gerar o export. Tente novamente.",
      },
    },
    creativityFieldLocks: {
      title: 'Textos impostos',
      description: 'Campos de criatividade cujo texto é imposto pela operadora: a plataforma os exibe desabilitados e já preenchidos com este texto. Editá-lo aqui não exige deploy.',
      filterAccount: 'Filtrar por conta',
      add: 'Novo texto',
      account: 'Conta',
      scenarioType: 'Scenario type',
      field: 'Campo',
      fieldHint: 'Só são listados os campos de criatividade do scenario type escolhido.',
      pickScenarioFirst: 'Escolha primeiro um scenario type.',
      text: 'Texto imposto',
      active: 'Ativo',
      actions: 'Ações',
      yes: 'Sim',
      no: 'Não',
      empty: 'Não há textos impostos configurados.',
      rawLength: '{n} caracteres sem resolver',
      addTitle: 'Novo texto imposto',
      editTitle: 'Editar texto imposto',
      scopeImmutable: 'A conta, o scenario type e o campo não são editáveis. Para mover, apague esta linha e crie outra.',
      tokensHelp: 'A plataforma substitui estes tokens pelos dados do template ao criar a criatividade. Qualquer outro {TOKEN} é rejeitado porque seria enviado literalmente ao dispositivo.',
      satLengthWarning: 'O texto sem resolver tem {n} caracteres e um opt-in S@T admite {max}. Pode caber depois de resolver os tokens — verifique na plataforma.',
      cancel: 'Cancelar',
      save: 'Salvar',
      saved: 'Texto imposto salvo.',
      saveFailed: 'Não foi possível salvar o texto imposto.',
      propagationWarning: 'Ao salvar, as criatividades que já existem neste escopo são reescritas, resolvendo os tokens com o nome e o preço de cada template. Roda em segundo plano e é tudo ou nada: se uma falhar, nenhuma é modificada.',
      savedAndEnqueued: 'Salvo. A propagação para os templates existentes foi enfileirada.',
      savedEnqueueFailed: 'O texto foi salvo, mas não foi possível enfileirar a propagação: {error}. Use o botão de repropagar.',
      propagate: 'Repropagar para os templates existentes',
      propagateInactive: 'Um texto desativado não é propagado',
      propagationEnqueued: 'Propagação enfileirada.',
      propagationFailed: 'Não foi possível enfileirar a propagação.',
      loadFailed: 'Não foi possível carregar os textos impostos.',
      fieldsFailed: 'Não foi possível carregar os campos do scenario type.',
      remove: 'Apagar',
      removeTitle: 'Apagar texto imposto',
      removeConfirm: 'Apagar o texto imposto de {scope}?',
      removeWarning: 'O campo volta a ser editável na plataforma e ficará vazio nas criatividades novas.',
      removed: 'Texto imposto apagado.',
      removeFailed: 'Não foi possível apagar o texto imposto.',
      errTextRequired: 'O texto é obrigatório.',
      errAccountRequired: 'Escolha uma conta.',
      errScenarioTypeRequired: 'Escolha um scenario type.',
      errFieldRequired: 'Escolha um campo.',
    },
    // DD-1771 — idem en: no había bloque twoFactor en portugués.
    twoFactor: {
      title: 'Autenticação de dois fatores',
      subtitle: 'Adicione uma camada extra de segurança à sua conta.',
      disabledTitle: '2FA está desativado',
      disabledDescription: 'Ative a autenticação de dois fatores para proteger sua conta.',
      enable: 'Ativar 2FA',
      enabledTitle: '2FA está ativado',
      disable: 'Desativar 2FA',
      chooseMethod: 'Escolha como deseja receber o código de verificação.',
      methodEmail: 'Email',
      methodEmailDescription: 'Receba o código por email.',
      methodTotp: 'App autenticador',
      methodTotpDescription: 'Use Google Authenticator, Authy ou similar.',
      cancel: 'Cancelar',
      scanQr: 'Escaneie este código QR com seu app autenticador.',
      manualKey: 'Ou digite esta chave manualmente',
      copy: 'Copiar',
      copied: 'Chave copiada',
      enterCode: 'Digite o código de 6 dígitos do seu app',
      verifyAndEnable: 'Verificar e ativar',
      back: 'Voltar',
      disableWarning: 'Isso reduz a segurança da sua conta. Você pode ativá-lo novamente quando quiser.',
      enterCurrentCode: 'Digite seu código atual de 6 dígitos para confirmar',
      confirmDisable: 'Desativar',
      errorGeneric: 'Ocorreu um erro. Tente novamente.',
      errorInvalidCode: 'Código de verificação inválido.',
      requiredHint: 'Sua conta exige autenticação de dois fatores: não pode ser desativada.',
      forcedTitle: 'Configure a autenticação de dois fatores',
      forcedSubtitle: 'Sua conta exige 2FA. Configure-o para entrar.',
      emailCodeSent: 'Enviamos um código de 6 dígitos para o seu email.',
      enterEmailCode: 'Digite o código que você recebeu por email',
      verifyAndContinue: 'Verificar e continuar',
      changeMethod: 'Trocar método',
      backToLogin: 'Voltar ao login',
    },
    accountTwoFactor: {
      label: '2FA obrigatório para os usuários desta conta',
      chipRequired: '2FA obrigatório',
      chipOptional: '2FA opcional',
      enableTitle: 'Ativar 2FA obrigatório',
      enableText: '{pending} de {total} usuários ainda não têm 2FA: será solicitado que o configurem no próximo login.',
      disableTitle: 'Desativar 2FA obrigatório',
      disableText: 'O 2FA passa a ser opcional para os usuários desta conta. Quem já o configurou o mantém.',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      saveError: 'Não foi possível alterar o 2FA obrigatório da conta.',
      loadError: 'Não foi possível carregar o status de 2FA da conta.',
      title: 'Verificação em duas etapas (2FA)',
      descriptionOn: 'Todos os usuários atribuídos a esta conta devem usar 2FA. Quem ainda não o configurou fará isso no próximo login.',
      descriptionOff: 'Ative para exigir 2FA de todos os usuários atribuídos a esta conta, novos e existentes.',
      usersSummary: '{total} usuários na conta · {pending} sem 2FA',
      allConfigured: 'Todos os usuários da conta têm 2FA',
      allConfiguredNonExempt: 'Todos os usuários não isentos têm 2FA',
      exemptSummary: '{count} isento | {count} isentos',
      enableAction: 'Exigir 2FA',
      disableAction: 'Deixar de exigir',
      superadminOnly: 'Só um superadmin pode alterar.',
    },
    userTwoFactorReset: {
      button: 'Redefinir 2FA',
      title: 'Confirmar redefinição do 2FA',
      question: 'Tem certeza de que deseja redefinir a autenticação em duas etapas (2FA) do usuário {username}?',
      description: 'A configuração atual de 2FA (app autenticador ou e-mail) será removida. Se alguma das contas dele exigir 2FA, ele terá que configurá-lo de novo no próximo login.',
      cancel: 'Cancelar',
      confirm: 'Redefinir 2FA',
    },
    channelPrices: {
      title: 'Preços de canais',
      description: 'Configure o preço unitário por canal faturável para cada conta. Os preços são versionados por data — alterar um preço nunca sobrescreve o histórico.',
      account: 'Conta',
      selectAccount: 'Selecione uma conta para ver e configurar os preços.',
      channel: 'Canal',
      currentPrice: 'Preço atual',
      currency: 'Moeda',
      validFrom: 'Vigente desde',
      actions: 'Ações',
      notSet: '— não configurado —',
      changePrice: 'Alterar preço',
      history: 'Histórico',
      hideHistory: 'Ocultar histórico',
      noHistory: 'Não há preços anteriores para este canal.',
      price: 'Preço',
      validTo: 'Vigente até',
      current: '— vigente —',
      changePriceTitle: 'Alterar preço — {channel}',
      changePriceHelper: 'Cria uma nova linha de preço e fecha a vigente no dia anterior. O preço anterior fica disponível para relatórios de meses anteriores.',
      newPrice: 'Novo preço',
      cancel: 'Cancelar',
      save: 'Salvar',
      priceUpdated: 'Preço atualizado',
      priceSaveFailed: 'Não foi possível salvar o preço',
      selectAccountFirst: 'Selecione uma conta primeiro',
      errPriceNonNegative: 'O preço deve ser um número maior ou igual a zero',
      errCurrency: 'A moeda deve ser um código de 3 letras (por exemplo USD)',
      errValidFrom: 'A data "Vigente desde" deve estar no formato YYYY-MM-DD',
      mode: 'Modalidade',
      modeFixed: 'Fixo',
      modeVariable: 'Variável',
      modeTiered: 'Por faixas',
      helpFixed: 'Um único preço por envio. Custo total = envios × preço.',
      helpVariable: 'O volume total do mês cai em uma faixa e todos os envios são cobrados ao preço dessa faixa.',
      helpTiered: 'Cada faixa é cobrada ao seu próprio preço, acumulativo sobre o volume do mês.',
      tiersSummary: '{n} faixas',
      tiersDetail: 'Faixas configuradas:',
      tierFrom: 'Desde (unidades)',
      tierPrice: 'Preço',
      addTier: 'Adicionar faixa',
      errAtLeastOneTier: 'Configure pelo menos uma faixa',
      errFirstTierZero: 'A primeira faixa deve começar em 0',
      errTierFromInteger: 'O início da faixa deve ser um inteiro não-negativo',
      errTierPriceNonNegative: 'O preço da faixa deve ser maior ou igual a zero',
      errTierIncreasing: 'As faixas devem ser estritamente crescentes por unidades'
    }
  }
}
